
const translations = {
    "Notice!": "Paziņojums!",
    "Are you sure that you want to delete this?": "Vai tiešām vēlaties to dzēst?",
    "Confirm": "Apstiprināt",
    "Cancel": "Atcelt",
    "Min": "Min",
    "Max": "Maks",
    "Before": "Pirms tam",
    "After": "Pēc",
    "w": "n",
    "week": "nedēļa",
    "weeks": "nedēļas",
    "d": "d",
    "day": "diena",
    "days": "dienas",
    "Due date": "Gala termiņš",
    "Start date": "Sākuma datums",
    "Internal date": "Iekšējais datums",
    "Notes": "Piezīmes",
    "Document": "Dokuments",
    "Email": "E-pasts",
    "Billing": "Rēķini",
    "Add": "Pievienot",
    "Archived": "Arhivēts",
    "Cancelled": "Atcelts",
    "Active": "Aktīvs",
    "Inactive": "Neaktīvs",
    "Client company": "Klienta uzņēmums",
    "General info": "Vispārīga informācija",
    "Digitisation of client documents": "Klientu dokumentu digitalizācija",
    "Client portal": "Klientu portāls",
    "Documents": "Dokumenti",
    "Members": "Biedri",
    "Preferences": "Preferences",
    "Yes": "Jā",
    "No": "Nē",
    "Total hours": "Kopējās stundas",
    "Extra hours": "Papildu stundas",
    "Client": "Klients",
    "Tasks": "Uzdevumi",
    "Disable Uku’s task templates": "Atspējot Uku uzdevumu veidnes",
    "Set the estimation as time when the exact value is not entered": "Iestatiet aprēķinu kā laiku, kad nav ievadīta precīza vērtība",
    "Checklist must be completed to finish the task": "Lai pabeigtu uzdevumu, ir jāaizpilda kontrolsaraksts",
    "Disable topic management for members": "Atspējot tēmu pārvaldību dalībniekiem",
    "Disable time edit for members": "Atspējot dalībnieku laika rediģēšanu",
    "Allow time entries in future": "Atļaut laika ierakstus nākotnē",
    "Show all dependent tasks in the calendar": "Show all dependent tasks in the calendar",
    "Clients": "Klienti",
    "Disable adding new clients for members": "Atspējot jaunu klientu pievienošanu dalībniekiem",
    "Only administrators can edit documents": "Tikai administratori var rediģēt dokumentus",
    "Allow digitisation of client documents": "Ļauj klientu dokumentu digitalizāciju",
    "Use my Microsoft account": "Izmantojiet manu Microsoft kontu",
    "Disconnect my Microsoft account": "Atvienojiet manu Microsoft kontu",
    "Connect my Microsoft account": "Pievienojiet manu Microsoft kontu",
    "Use my google account": "Izmantojiet manu Google kontu",
    "Connect my google account": "Pievienojiet manu Google kontu",
    "Disconnect my google account": "Atvienot manu Google kontu",
    "Emails": "E-pasti",
    "Daily agenda": "Dienas kārtība",
    "Unread notifications": "Nelasīti paziņojumi",
    "Task assigned to me": "Man uzticēts uzdevums",
    "Weekly summary": "Nedēļas kopsavilkums",
    "Monthly summary": "Mēneša kopsavilkums",
    "Updates and tips": "Atjauninājumi un padomi",
    "Overdue": "Nokavēts",
    "1 day": "1 diena",
    "1 day overdue": "1 dienu nokavēts",
    "{0} days": "{0} dienas",
    "{0} days overdue": "{0} dienas nokavēts",
    "{0} minute ago": "{0} pirms minūtes",
    "{0} minutes ago": "pirms {0} minūtēm",
    "{0} hour ago": "{0} pirms stundas",
    "{0} hours ago": "{0} stundas atpakaļ",
    "Sunday": "Svētdiena",
    "Monday": "Pirmdiena",
    "Tuesday": "Otrdiena",
    "Wednesday": "Trešdiena",
    "Thursday": "Ceturtdiena",
    "Friday": "Piektdiena",
    "Saturday": "Sestdiena",
    "Sun": "Sv",
    "Mon": "Pirm",
    "Tue": "Otr",
    "Wed": "Trešd",
    "Thu": "Cet",
    "Fri": "Piekt",
    "Sat": "Sest",
    "January": "Janvāris",
    "February": "Februāris",
    "March": "Marts",
    "April": "Aprīlis",
    "May": "Mai",
    "June": "Jūnijs",
    "July": "Jūlijs",
    "August": "Augusts",
    "September": "Septembris",
    "October": "Oktobris",
    "November": "Novembris",
    "December": "Decembris",
    "Jan": "Jan",
    "Feb": "Feb",
    "Mar": "Mar",
    "Apr": "Apr",
    "Jun": "Jūn",
    "Jul": "Jūl",
    "Aug": "Aug",
    "Sep": "Sep",
    "Oct": "Okt",
    "Nov": "Nov",
    "Dec": "Dec",
    "Today": "Šodien",
    "Yesterday": "Vakar",
    "Day": "Diena",
    "Days": "Dienas",
    "+{0} d": "+{0} d",
    "+{0} wd": "+{0} wd",
    "Weekly {0}": "Iknedēļas {0}",
    "Every {0}. week {1}": "Ik pēc {0}. nedēļa {1}",
    "{0}": "{0}",
    "Monthly {0}. d": "Ikmēneša {0}. d",
    "Every {0}. month {1}. d": "Ik pēc {0}. mēnesis {1}. d",
    "{0}. d": "{0}. d",
    "Quarterly {0}. month {1}. d": "Ceturkšņa {0}. mēnesis {1}. d",
    "Every {0}. quarter {1}. month {2}. d": "Ik pēc {0}. ceturksnis {1}. mēnesis {2}. d",
    "{0}. month {1}. d": "{0}. mēnesis {1}. d",
    "Yearly {0}": "Gada {0}",
    "Every {0}. year {1}": "Ik pēc {0}. gads {1}",
    "Mo": "Pirm",
    "Tu": "Otrd",
    "We": "Trešd",
    "Th": "Cet",
    "Fr": "Pktd",
    "Sa": "Sest",
    "Su": "Sv",
    "and": "un",
    "{0}w": "{0}n",
    "{0}d": "{0}d",
    "before": "pirms",
    "after": "pēc",
    "Project": "Projekts",
    "Quarter": "Ceturksnis",
    "Add your photo": "Pievienojiet savu fotoattēlu",
    "Adding file failed": "Faila pievienošana neizdevās",
    "Please check the file.": "Lūdzu, pārbaudiet failu.",
    "You can only add pictures.": "Var pievienot tikai attēlus.",
    "Error": "Kļūda",
    "Create new topic": "Izveidot jaunu tēmu",
    "Name": "Vārds",
    "Close": "Aizvērt",
    "Find topic...": "Atrast tēmu...",
    "New topic": "Jauna tēma",
    "Invalid format": "Nederīgs formāts",
    "Demo company account": "Demo uzņēmuma konts",
    "Demo account will be deleted later. Do this for testing purposes only!": "Demo konts vēlāk tiks dzēsts. Dariet to tikai pārbaudes nolūkos!",
    "Subscribe": "Abonēt",
    "Start demo": "Sākt demonstrāciju",
    "End demo": "Beigt demonstrāciju",
    "Free trial is expired - {0}": "Bezmaksas izmēģinājuma periods ir beidzies — {0}",
    "Free trial {1} {2} left - {0}": "Bezmaksas izmēģinājuma periods: {1} atlikuši {2} — {0}",
    "Add time": "Pievienojiet laiku",
    "Billable": "Apmaksājams",
    "Date": "Datums",
    "Start": "Sākt",
    "End": "Beigas",
    "Duration": "Ilgums",
    "Split duration equally": "Sadaliet ilgumu vienādi",
    "Required field": "Obligāts lauks",
    "Members list": "Dalībnieku saraksts",
    "Edit fields": "Rediģēt laukus",
    "Maximum number of selected columns has been exceeded": "Ir pārsniegts maksimālais atlasīto kolonnu skaits",
    "If you want to add a new column to the report, please remove an existing one first.": "Ja vēlaties pārskatam pievienot jaunu sleju, lūdzu, vispirms noņemiet esošu.",
    "Snooze until...": "Atlikt līdz...",
    "Select date & time": "Izvēlieties datumu un laiku",
    "Tomorrow": "Rīt",
    "Later this week": "Vēlāk šonedēļ",
    "Next week": "Nākamnedēļ",
    "Add task": "Pievienojiet uzdevumu",
    "Checklist": "Kontrolsaraksts",
    "Start timer": "Sāciet taimeri",
    "Add an item": "Pievienojiet vienumu",
    "Add checklist item": "Pievienojiet kontrolsaraksta vienumu",
    "Convert to a task": "Pārvērst par uzdevumu",
    "Delete": "Dzēst",
    "Delegate to...": "Deleģēt uz...",
    "Please select tasks from the same account": "Lūdzu, atlasiet uzdevumus no tā paša konta",
    "Follow": "Sekojiet",
    "Expand sidebar": "Izvērst sānu joslu",
    "Nicely done!": "Labi darīts!",
    "You've finished all your tasks, take a second to recharge": "Jūs esat pabeidzis visus savus uzdevumus, atpūtieties mazliet",
    "Search tasks...": "Meklēt uzdevumus...",
    "Search": "Meklēt",
    "select/unselect all": "atlasīt/noņemt atlasi visu",
    "Add new client": "Pievienot jaunu klientu",
    "Account": "Konts",
    "Client name": "Klienta vārds",
    "Select client": "Izvēlieties klientu",
    "New client": "Jauns klients",
    "Must be an integer": "Jābūt veselam skaitlim",
    "Must be a number": "Jābūt skaitlim",
    "Dashboard": "Mērinstrumentu panelis",
    "Calendar": "Kalendārs",
    "Report": "Ziņot",
    "Monitoring": "Uzraudzība",
    "Suppliers": "Piegādātāji",
    "Events": "Pasākumi",
    "Projects": "Projekti",
    "Help": "Palīdzība",
    "Settings & Apps": "Iestatījumi un lietotnes",
    "Profile": "Profils",
    "Collapse menu": "Sakļaut izvēlni",
    "Expand menu": "Izvērst izvēlni",
    "Are you sure to delete this attachment?": "Vai tiešām dzēsīsiet šo pielikumu?",
    "Select": "Izvēlieties",
    "Edit contacts": "Koriģēt kontaktus",
    "Add member": "Pievienot dalībnieku",
    "Add note": "Pievienot piezīmi",
    "Open": "Open",
    "Reports": "Pārskati",
    "Billing notes": "Rēķini piezīmes",
    "Pinned notes": "Piespraustas piezīmes",
    "Sub-companies": "Apakšuzņēmumi",
    "Contacts": "Kontakti",
    "Event info": "Informācija par pasākumu",
    "Project info": "Informācija par projektu",
    "Summary": "Kopsavilkums",
    "Task": "Uzdevums",
    "Time": "Laiks",
    "Collapse sidebar": "Sānu joslas sabrukšana",
    "Client Overview": "Klienta pārskats",
    "Event Overview": "Pasākuma pārskats",
    "Project Overview": "Projekta pārskats",
    "Edit client": "Rediģēt klientu",
    "Edit event": "Rediģēt notikumu",
    "Edit project": "Rediģēt projektu",
    "Show all": "Parādīt visu",
    "Collapse": "Sakļaut",
    "by": "autors",
    "View all": "Apskati visus",
    "Add company event": "Pievienot uzņēmuma pasākumu",
    "Company": "Uzņēmums",
    "Info": "Informācija",
    "Holiday": "Atpūta",
    "All day(s)": "Visas dienas",
    "End date": "Beigu datums",
    "From": "No",
    "Until": "Līdz",
    "Hours": "Stundas",
    "Link": "Saite",
    "Save": "Saglabāt",
    "Are you sure that you want to delete this company calendar event?": "Vai esat pārliecināts, ka vēlaties dzēst šo uzņēmuma kalendāra notikumu?",
    "Location of client folder in your document management system": "Location of client folder in your document management system",
    "Defined main folder": "Defined main folder",
    "Custom folder": "Custom folder",
    "Add new role": "Pievienojiet jaunu lomu",
    "New role": "Jauna loma",
    "Access enabled": "Piekļuve iespējota",
    "Waiting for files": "Gaida failus",
    "Uploaded": "Augšupielādēts",
    "Uploading...": "Notiek augšupielāde...",
    "Client members": "Klientu dalībnieki",
    "Email settings": "E-pasta iestatījumi",
    "Or connect new email address": "Vai pievienojiet jaunu e-pasta adresi",
    "Connect with Microsoft Exchange or other email server (SMTP)": "Izveidojiet savienojumu ar Microsoft Exchange vai citu e-pasta serveri (SMTP)",
    "Test email sent": "Testa e-pasts nosūtīts",
    "Email address": "Epasta adrese",
    "Reply address": "Atbildes adrese",
    "Sender name": "Sūtītāja vārds",
    "Who can use?": "Kurš var izmantot?",
    "Client default address": "Klienta noklusējuma adrese",
    "Invalid e-mail": "Nepareizs e-pasts",
    "Role": "Loma",
    "E-mail": "E-pasts",
    "Mobile phone": "Mobilais telefons",
    "Work phone": "Darba telefons",
    "Language": "Valoda",
    "Birthday": "Dzimšanas diena",
    "Are you sure to delete this contact?": "Vai tiešām dzēsīsiet šo kontaktpersonu?",
    "Manage contact fields": "Kontaktu lauku pārvaldība",
    "Administrative Assistant": "Administratīvais asistents",
    "Board member": "Valdes loceklis",
    "CEO": "Izpilddirektors",
    "Add contact": "Pievienot kontaktu",
    "Contact person": "Kontaktpersona",
    "Leave page?": "Pamest lapu?",
    "Changes that you made may not be saved": "Jūsu veiktās izmaiņas var netikt saglabātas",
    "Leave": "Aiziet",
    "Super! We're importing your clients...": "Super! Mēs importējam jūsu klientus...",
    "Feel free to leave this page. We will pop up a notification when the import is prepared. Then you need to confirm the clients you want to add to Uku.": "Variet droši atstāt šo lapu. Kad importēšana būs sagatavota, mēs parādīsim paziņojumu. Pēc tam jums ir jāapstiprina klienti, kurus vēlaties pievienot Uku.",
    "Please wait...": "Lūdzu uzgaidiet...",
    "Setup API keys": "Iestatīt API atslēgas",
    "You have two options": "Jums ir divas iespējas",
    "how to setup API keys": "kā iestatīt API atslēgas",
    "Continue": "Turpināt",
    "Custom import": "Pielāgots imports",
    "To import clients and volume of work from !INTEGRATION, Uku needs !INTEGRATION API key for every client.": "Lai importētu klientus un darba apjomu no !INTEGRATION, Uku ir nepieciešama !INTEGRATION API atslēga katram klientam.",
    "1. <span class=font-weight-medium>Continue</span> - Uku automatically creates API keys for every client": "1. <span class=font-weight-medium>Turpināt</span> — Uku automātiski izveido API atslēgas katram klientam",
    "1. <span class=font-weight-medium>Custom import</span> - Uku connects only with existing UKU API keys. Create API keys manually in !INTEGRATION before import. Read:": "1. <span class=font-weight-medium>Pielāgota importēšana</span> — Uku savienojas tikai ar esošajām UKU API atslēgām. Pirms importēšanas manuāli izveidojiet API atslēgas programmā !INTEGRATION. Lasīt:",
    "(it takes a lot of time)": "(tas aizņem daudz laika)",
    "Import Clients": "Importēt klientus",
    "Country": "Valsts",
    "Please choose your country": "Lūdzu, izvēlieties savu valsti",
    "Password": "Parole",
    "Start import": "Sākt importēšanu",
    "Insert !INTEGRATION login details (it’s secure) to give one time access to import clients and API keys. Please note that you will get logged out from !INTEGRATION in other browsers.": "Ievietojiet !INTEGRATION pieteikšanās informāciju (tas ir droši), lai nodrošinātu vienreizēju piekļuvi klientu un API atslēgām. Lūdzu, ņemiet vērā, ka jūs tiksiet atteicies no !INTEGRATION citās pārlūkprogrammās.",
    "Update invoice status": "Atjaunināt rēķina statusu",
    "Update now": "Atjaunināt tagad",
    "Daily @ 14:00": "Katru dienu 14:00",
    "Daily @ 18:00": "Katru dienu 18:00",
    "Updating invoice statuses, please wait...": "Notiek rēķinu statusu atjaunināšana, lūdzu, uzgaidiet...",
    "Your import is ready": "Jūsu importēšana ir gatava",
    "In the final step you need to confirm the clients you want to add to uku": "Pēdējā darbībā jums ir jāapstiprina klienti, kurus vēlaties pievienot uku",
    "Let's go": "Ejam",
    "Import again": "Importējiet vēlreiz",
    "Do you have new clients to import?": "Vai jums ir jauni klienti, ko importēt?",
    "Yes, i do": "Jā",
    "View last import": "Skatīt pēdējo importēšanu",
    "Email server": "E-pasta serveris",
    "Email provider": "E-pasta pakalpojumu sniedzējs",
    "Host": "Saimnieks",
    "Port": "Ports",
    "Security": "Drošība",
    "Sender email": "Sūtītāja e-pasts",
    "Username": "Lietotājvārds",
    "Test connection": "Pārbaudīt savienojumu",
    "How to set up": "Kā iestatīt",
    "Only administrators can activate the app": "Tikai administratori var aktivizēt lietotni",
    "You are in the waiting list": "Jūs esat gaidīšanas sarakstā",
    "We onboard all applicants one by one": "Atzīmējiet savu interesi, un mēs jums paziņosim, kad aplikācija būs pieejama testēšanai",
    "Connected": "Savienots",
    "Activated": "Aktivēts",
    "Join waiting list": "Vēlos mēģināt",
    "Activate": "Aktivizēt",
    "Unsubscribe from waiting list": "Atteikties no gaidīšanas saraksta",
    "Deactivate app": "Deaktivizēt lietotni",
    "Disconnect": "Atvienoties",
    "Hide expanded content": "Hide expanded content",
    "Show trimmed content": "Show trimmed content",
    "Email not delivered": "E-pasts nav piegādāts",
    "Sent, but fallback to Uku email": "Nosūtīts, bet atgriešanās uz Uku e-pastu",
    "Unknown error": "Nepazīstama kļūda",
    "to": "uz",
    "in any minute": "jebkurā minūtē",
    "on {0},": "{0},",
    "or": "vai",
    "Send now": "Sūtīt tagad",
    "Uku <span class='subtitle-2'>is sending</span> email": "Uku <span class='subtitle-2'>sūta</span> e-pasta ziņojumu",
    "__From_email": "__From_email",
    "Set up email": "Iestatiet e-pastu",
    "Client default": "Klienta noklusējums",
    "Subject": "Temats",
    "Edit email": "Rediģēt e-pastu",
    "Template": "Veidne",
    "Cc": "Kopija",
    "Bcc": "Diskrētā kopija",
    "__To_email": "__To_email",
    "__Cc_email": "__Cc_email",
    "__Bcc_email": "__Bcc_email",
    "Add template": "Pievienojiet veidni",
    "Add automation": "Pievienojiet automatizāciju",
    "Add placeholder": "Pievienojiet vietturi",
    "Format text": "Formatēt tekstu",
    "Add attachment": "Pievienojiet pielikumu",
    "Send": "Sūtīt",
    "Save automation": "Saglabājiet automatizāciju",
    "Choose email template": "Izvēlieties e-pasta veidni",
    "All languages": "Visas valodas",
    "No templates found.": "Nav atrasta neviena veidne.",
    "Edit email template": "Rediģēt e-pasta veidni",
    "Are you sure you want to delete this template? Some tasks will be affected": "Vai tiešām vēlaties dzēst šo veidni? Tiks ietekmēti daži uzdevumi",
    "Are you sure you want to delete this template?": "Vai tiešām vēlaties dzēst šo veidni?",
    "Are you sure you want to save this template, the following tasks will be affected?": "Vai tiešām vēlaties saglabāt šo veidni, jo tiks ietekmēti tālāk norādītie uzdevumi?",
    "Template name": "Veidnes nosaukums",
    "Edit template": "Rediģēt veidni",
    "Send email": "Sūtīt e-pastu",
    "on": "ieslēgts",
    "Ok": "Labi",
    "Supplier": "Piegādātājs",
    "Event": "Notikums",
    "Contact": "Sazināties",
    "Validation failed": "Validācija neizdevās",
    "Saving supplier failed": "Saglabāt piegādātāju neizdevās",
    "Saving client failed": "Klienta saglabāšana neizdevās",
    "Saving project failed": "Projekta saglabāšana neizdevās",
    "several values": "vairākas vērtības",
    "values": "vērtības",
    "is": "ir",
    "Add filter": "Pievienojiet filtru",
    "Update": "Atjaunināt",
    "forever": "uz visiem laikiem",
    "Last week": "Pagājušajā nedēļā",
    "This week": "Šonedēļ",
    "Last month": "Pagājušajā mēnesī",
    "This month": "Šis mēnesis",
    "Next month": "Nākammēnes",
    "Last year": "Pagājušais gads",
    "This year": "Šogad",
    "This quarter": "Šajā ceturksnī",
    "Next quarter": "Nākamais ceturksnis",
    "Last quarter": "Pēdējais ceturksnis",
    "Client group": "Klientu grupa",
    "Topic": "Temats",
    "Member": "Biedrs",
    "Primary member": "Galvenais biedrs",
    "Client status": "Klienta statuss",
    "Active clients": "Aktīvie klienti",
    "Inactive clients": "Neaktīvie klienti",
    "All": "Visi",
    "Project status": "Projekta statuss",
    "Member status": "Dalībnieka statuss",
    "Active members": "Aktīvie dalībnieki",
    "Limited members": "Ierobežots dalībnieku skaits",
    "Inactive members": "Neaktīvie dalībnieki",
    "Contract status": "Līguma statuss",
    "Active contracts": "Aktīvie līgumi",
    "Pending contracts": "Neapstiprinātie līgumi",
    "Finished contracts": "Pabeigtie līgumi",
    "Contract template": "Līguma veidne",
    "Payment recurrence": "Maksājuma atkārtošanās",
    "Yearly": "Ik gadu",
    "Monthly": "Ikmēneša",
    "Trial": "Izmēģinājums",
    "Region": "Novads",
    "Field": "Lauks",
    "All tasks": "Visi uzdevumi",
    "Todo": "Darāmais",
    "Not done": "Nav izdarīts",
    "Done": "Gatavs",
    "Delayed": "Kavējas",
    "Important": "Svarīgs",
    "Extra work": "Papildus darbs",
    "I Follow": "Es sekoju",
    "Commented": "Komentēja",
    "Tracked time": "Uzskaitīts laiks",
    "Estimated": "Aptuvenais",
    "Recurring task": "Atkārtots uzdevums",
    "Last import": "Pēdējā importēšana",
    "Period": "Periods",
    "Client search": "Klientu meklēšana",
    "Voucher": "Kupons",
    "Company status": "Uzņēmuma statuss",
    "Deleted": "Izdzēsts",
    "All status": "Viss statuss",
    "Payment gateway": "Maksājumu vārteja",
    "All gateways": "Visi vārti",
    "Uku manually": "Uku manuāli",
    "Braintree": "Braintri",
    "Plan status": "Plāna statuss",
    "All plans": "Visi plāni",
    "Paid": "Apmaksāts",
    "Paid churn": "Apmaksāts klientu skaita samazinājums",
    "Trial churn": "Izmēģinājuma izdzīvošana",
    "Plan period": "Plāna periods",
    "All periods": "Visi periodi",
    "Monthly plan": "Mēneša plāns",
    "Yearly plan": "Gada plāns",
    "Company search": "Uzņēmuma meklēšana",
    "User search": "Lietotāju meklēšana",
    "Name key search": "Vārda atslēgas meklēšana",
    "None filter": "Nav filtru",
    "OK": "labi",
    "Start date cannot be later than due date": "Sākuma datums nevar būt vēlāks par termiņa beigu datumu",
    "tasks": "uzdevumus",
    "task(s) had errors": "uzdevumā(-os) bija kļūdas",
    "tasks selected": "atlasīti uzdevumi",
    "Postpone": "Atlikt",
    "Mark done": "Atzīmēt gatavu",
    "Hide multiselect": "Paslēpt vairāku atlasi",
    "Delete task(s)": "Dzēst uzdevumu(s)",
    "All of the data related to the task will be deleted": "Visi ar uzdevumu saistītie dati tiks dzēsti",
    "Some tasks include other people. Are you sure you want to delete?": "Daži uzdevumi ietver citus cilvēkus. Vai esat pārliecināts, ka vēlaties dzēst?",
    "Time has been tracked to some of the selected activities. Are you sure you want to delete?": "Dažām izvēlētajām darbībām ir izsekots laiks. Vai esat pārliecināts, ka vēlaties dzēst?",
    "Time has been tracked to some of the selected activities. Some tasks include other people. Are you sure you want to delete?": "Dažām izvēlētajām darbībām ir izsekots laiks. Dažos uzdevumos ir iesaistīti citi cilvēki. Vai esat pārliecināts, ka vēlaties dzēst?",
    "task(s) were not marked done": "uzdevums(i) netika atzīmēti kā izpildīti",
    "Please check if the checklist has been completed or time is entered and they are assigned to you": "Lūdzu, pārbaudiet, vai kontrolsaraksts ir aizpildīts vai ir ievadīts laiks un tie ir jums piešķirti",
    "task(s) were not deleted": "uzdevums(-i) netika dzēsts(-i)",
    "task(s) time was not updated": "uzdevuma(-u) laiks netika atjaunināts",
    "Please make sure that you can add time to task": "Lūdzu, pārliecinieties, vai varat pievienot laiku uzdevumam",
    "invoice table row": "rēķina tabulas rinda",
    "invoice table row(s) had errors": "rēķina tabulas rindā(s) bija kļūdas",
    "invoice table row(s) selected": "atlasīta(-as) rēķina tabulas rinda(-as)",
    "Create": "Izveidot",
    "Mark paid": "Atzīmēt kā apmaksātu",
    "Send to client": "Nosūtīt klientam",
    "Recalculate": "Pārrēķināt",
    "Export to {0}": "Eksportēt uz {0}",
    "Update Status from {0}": "Atjaunināt statusu no {0}",
    "Void invoice": "Nederīgs rēķins",
    "Delete invoice": "Dzēst rēķinu",
    "Restore invoice": "Atjaunot rēķinu",
    "Mark unpaid": "Atzīmēt kā neapmaksātu",
    "Invoices": "Rēķini",
    "Download to Excel": "Lejupielādēt programmā Excel",
    "Revenue split": "Ieņēmumu sadalījums",
    "Tax": "Nodoklis",
    "Description": "Apraksts",
    "Percent": "Procenti",
    "Integration Id": "Integrācijas Id",
    "Integration Code": "Integrācijas kods",
    "Name on invoice": "Nosaukums uz rēķina",
    "Restore": "Atjaunot",
    "Archive": "Arhīvs",
    "Hide": "Slēpt",
    "Are you sure?": "Vai esi pārliecināts?",
    "Import finished!": "Importēšana ir pabeigta!",
    "Failed to import {0} records": "Neizdevās importēt {0} ierakstus",
    "Download report": "Lejupielādēt ziņojumu",
    "Result: added {0}, updated {1}, skipped {2}, failed to import {3}": "Rezultāts: pievienots {0}, atjaunināts {1}, izlaists {2}, neizdevās importēt {3}",
    "Result: added {0}, updated {1}, skipped {2}": "Rezultāts: pievienots {0}, atjaunināts {1}, izlaists {2}",
    "What’s next?": "Ko tālāk?",
    "To work effectively with your client base, complete the following steps:": "Lai efektīvi strādātu ar savu klientu bāzi, veiciet tālāk norādītās darbības:",
    "Read more ›": "Lasīt vairāk >",
    "Next you will only see active imported clients. To see all clients, remove “Last import” filter.": "Tālāk jūs redzēsit tikai aktīvos importētos klientus. Lai skatītu visus klientus, noņemiet filtru “Pēdējā importēšana”.",
    "View clients": "Skatīt klientus",
    "Add <b>primary member</b> to every client.": "Pievienojiet <b>galveno dalībnieku</b> katram klientam.",
    "Add <b>task plan</b> to automate recurring tasks.": "Pievienojiet <b>uzdevumu plānu</b>, lai automatizētu periodiskos uzdevumus.",
    "Setup automatic monthly summary under {0} app in Uku to import volume of work.": "Iestatiet automātisku ikmēneša kopsavilkumu Uku lietotnē {0}, lai importētu darba apjomu.",
    "Title": "Nosaukums",
    "Field type": "Lauka veids",
    "Field name": "Lauka nosaukums",
    "Group name": "Grupas nosaukums",
    "Choices": "Izvēles",
    "Type each choice on a separate line": "Ierakstiet katru izvēli atsevišķā rindā",
    "Required": "Obligāti",
    "For all topics": "Visām tēmām",
    "For specific topics": "Konkrētām tēmām",
    "Topics": "Tēmas",
    "Non-billable": "Neapmaksājams",
    "Edit task custom field": "Rediģēt uzdevuma pielāgoto lauku",
    "Add task custom field": "Pievienojiet uzdevuma pielāgoto lauku",
    "Edit client custom field": "Rediģēt klienta pielāgoto lauku",
    "Add client custom field": "Pievienojiet klienta pielāgoto lauku",
    "Choice {0}": "Izvēle {0}",
    "Are you sure that you want to delete this custom field?": "Vai tiešām vēlaties dzēst šo pielāgoto lauku?",
    "Warning!": "Brīdinājums!",
    "This custom field is in use. Do you wish to archive it?": "Šis pielāgotais lauks tiek izmantots. Vai vēlaties to arhivēt?",
    "Reconnect": "Atkārtoti savienot",
    "Send test email": "Nosūtiet testa e-pastu",
    "Email address or username": "E-pasta adrese vai lietotājvārds",
    "Other": "Cits",
    "Set default email server for company": "Iestatiet uzņēmuma noklusējuma e-pasta serveri",
    "My default email": "Mans noklusējuma e-pasts",
    "Depends on": "Atkarīgs no",
    "Todo - Blocking": "Visu bloķēšana",
    "In progress - Blocking": "Notiek bloķēšana",
    "In progress": "Notiek",
    "Client code": "Klienta kods",
    "Primary user": "Galvenais lietotājs",
    "Added date": "Pievienots datums",
    "Updated": "Atjaunināts",
    "Contract count": "Līgumu skaits",
    "Integration": "Integrācija",
    "No data available": "Dati nav pieejami",
    "No results found": "Neviens meklēšanas rezultāts netika atrasts",
    "Loading": "Notiek ielāde",
    "Sort by": "Kārtot pēc",
    "Rows per page": "Rindu skaits lapā",
    "{0}-{1} of {2}": "{0}-{1} no {2}",
    "Ongoing": "Notiek",
    "important": "svarīgs",
    "Read more": "Lasīt vairāk",
    "Add to previous time entry": "Pievienot iepriekšējam laika ierakstam",
    "Add to next time entry": "Pievienot nākamajam ierakstam",
    "Add new task": "Pievienojiet jaunu uzdevumu",
    "Cut previous time entry": "Izgriezt iepriekšējā laika ierakstu",
    "Cut next time entry": "Izgriezt nākamās reizes ierakstu",
    "Missing time entry": "Trūkst laika ieraksta",
    "Overlapping time entries": "Laika ieraksti, kas pārklājas",
    "Member from custom fields": "Dalībnieks no pielāgotajiem laukiem",
    "Delegated to": "Deleģēts uz",
    "Delegated by": "Deleģēja",
    "Visible members": "Redzamie dalībnieki",
    "Member type": "Dalībnieka veids",
    "Groups": "Grupas",
    "Custom field": "Pielāgots lauks",
    "Contact search": "Kontaktu meklēšana",
    "Task start": "Uzdevuma sākums",
    "Task due": "Uzdevuma izpildes termiņš",
    "Task finish": "Uzdevuma pabeigšana",
    "Custom date": "Pielāgotais datums",
    "Never": "Nekad",
    "Agreed work is still expected": "Joprojām tiek gaidīts saskaņots darbs",
    "Accepted flextime": "Pieņemts elastīgais laiks",
    "Declined flextime": "Noraidīts elastīgais laiks",
    "Cancelled flextime": "Atcelts elastīgais laiks",
    "Updated flextime": "Atjaunināts elastīgais laiks",
    "Calendar deleted": "Kalendārs izdzēsts",
    "Calendar created": "Kalendārs izveidots",
    "Calendar approved": "Kalendārs apstiprināts",
    "Calendar declined": "Kalendārs noraidīts",
    "Calendar updated": "Kalendārs atjaunināts",
    "Flextime balance updated": "Atjaunināts elastīgā darba laika līdzsvars",
    "Flextime": "Flextime jeb Elastīgs laiks",
    "Vacation": "Atvaļinājums",
    "Balance": "Līdzsvars",
    "Comment": "Komentēt",
    "History": "Vēsture",
    "Action": "Darbība",
    "Who": "PVO",
    "Take a vacation or mark an absence": "Paņemiet atvaļinājumu vai atzīmējiet prombūtni",
    "Away": "Prom",
    "Flextime bonus": "Flextime bonuss",
    "Approver": "Apstiprinātājs",
    "Vacation available": "Pieejamas brīvdienas",
    "Type": "Tips",
    "Reduce agreed working hours": "Samazināt noteikto darba laiku",
    "Reject": "Noraidīt",
    "Approve": "Apstiprināt",
    "away_type_Away": "away_type_Away",
    "Sick leave": "Darbnespējas atvaļinājums",
    "Parental leave": "Bērna kopšanas atvaļinājums",
    "Working hours": "Working hours",
    "Mon-Fri, 40h weekly, 8h daily": "Mon-Fri, 40h weekly, 8h daily",
    "Customize": "Customize",
    "Total": "Kopā",
    "Settings": "Iestatījumi",
    "Work on holidays": "Darbs brīvdienās",
    "Expand": "Izvērst",
    "Wait until event status": "Pagaidiet līdz notikuma statusam",
    "Wait until project status": "Pagaidiet, kamēr projekta statuss",
    "Week(s)": "Nedēļa(s)",
    "Day(s)": "Diena(s)",
    "Rule": "Noteikums",
    "Depends on event": "Atkarībā no notikuma",
    "Depends on project": "Atkarībā no projekta",
    "Due date in": "Izpildes datums",
    "Status": "Statuss",
    "Select event": "Izvēlieties notikumu",
    "Select project": "Izvēlieties projektu",
    "Find event...": "Atrodiet pasākumu...",
    "Find project...": "Atrodiet projektu...",
    "Custom recurrence": "Pielāgota atkārtošanās",
    "Every": "Katrs",
    "In case of holiday": "Svētku gadījumā",
    "Set time": "Uzstādīt laiku",
    "Start time": "Sākuma laiks",
    "Repeat from": "Atkārtot no",
    "Previous repeat from: {0}": "Iepriekšējais atkārtojums no: {0}",
    "On date": "Datumā",
    "Plus days": "Plus dienas",
    "Due date time": "Izpildes datums, laiks",
    "Remove recurrence": "Noņemt atkārtošanos",
    "Repeat": "Atkārtot",
    "month": "mēnesis",
    "quarter": "ceturksnis",
    "year": "gads",
    "1st month": "1. mēnesis",
    "2nd month": "2. mēnesis",
    "3rd month": "3. mēnesis",
    "Day {0}": "{0}. diena",
    "Show before": "Rādīt iepriekš",
    "Keep the day": "Saglabā dienu",
    "Show after": "Rādīt pēc",
    "From start date": "No sākuma datuma",
    "From beginning of the month": "No mēneša sākuma",
    "All days (Mon to Sun)": "Visas dienas (no pirmdienas līdz svētdienai)",
    "Mon to Fri (incl. holidays)": "No pirmdienas līdz piektdienai (ieskaitot svētku dienas)",
    "Mon to Fri (excl. holidays)": "No pirmdienas līdz piektdienai (izņemot brīvdienas)",
    "1st": "1",
    "2nd": "2",
    "3rd": "3",
    "Does not repeat": "Neatkārtojas",
    "Daily": "Ikdienas",
    "Weekly on {0}": "Katru nedēļu {0}",
    "Monthly on day {0}": "Katru mēnesi {0}. dienā",
    "Quarterly on {0} month {1} day": "Reizi ceturksnī {0} mēneša {1} dienā",
    "Yearly on {0} {1}": "Katru gadu {0} {1}",
    "Custom...": "Pielāgots...",
    "Incorrect time": "Nepareizs laiks",
    "Add repeat": "Pievienojiet atkārtojumu",
    "Email added to queue": "E-pasts ir pievienots rindai",
    "Communication timeline": "Komunikācijas laika skala",
    "Activate Email App in App Store to send automated emails and view your past and future communication in one place.": "Aktivizējiet e-pasta lietotni App Store, lai nosūtītu automatizētus e-pasta ziņojumus un vienuviet skatītu savu iepriekšējo un turpmāko saziņu.",
    "Go to App Store": "Iestatiet lietotni",
    "Unknown": "Nezināms",
    "<b>Email</b> from": "<b>E-pasts</b> no",
    "To": "Kam",
    "Planned": "Plānots",
    "Automated emails scheduled to be sent in the future": "Nākotnē plānots nosūtīt automatizētus e-pasta ziņojumus",
    "Send e-mail": "Sūtīt e-pastu",
    "Template unlinked": "Veidne ir atsaistīta",
    "Icon": "Ikona",
    "Link name": "Link name",
    "Link URL": "Link URL",
    "Open in new tab": "Open in new tab",
    "Visible": "Redzams",
    "External": "External",
    "Not external": "Not external",
    "Company default": "Uzņēmuma saistību neizpilde",
    "Not visible": "Not visible",
    "Use company default": "Use company default",
    "or choose icon": "or choose icon",
    "Find member...": "Atrast dalībnieku...",
    "I'll take it": "Es ņemšu to",
    "Remove me": "Noņemt mani",
    "Remove from task": "Noņemt no uzdevuma",
    "Learn more": "Uzzināt vairāk",
    "Company settings edit is disabled by owner": "Uzņēmuma iestatījumu rediģēšana ir atspējota pēc īpašnieka",
    "<b>Exported</b> {0} to {1}": "<b>Eksportēts</b> {0} uz {1}",
    "<b>Sent to client</b> {0} from {1}": "<b>Sent to client</b> {0} from {1}",
    "<b>Paid {0}</b> {1}": "<b>Apmaksāts {0}</b> {1}",
    "<b>Annulled</b> {0}": "<b>Anulēts</b> {0}",
    "Do you wish to mark the task done for everyone?": "Vai vēlaties atzīmēt paveikto uzdevumu visiem?",
    "No, remove me": "Nē, noņemiet mani",
    "Task won’t be marked done, but user is removed from the assignees and added to the followers of the task": "Uzdevums netiks atzīmēts kā veikts, bet lietotājs tiek noņemts no uzdevuma saņēmējiem un pievienots uzdevuma sekotājiem",
    "Invalid email": "Nepareizs e-pasts",
    "Accounting": "Grāmatvedība",
    "General": "Vispārīgi",
    "Advertising / Marketing/ PR": "Reklāma / Mārketings/ PR",
    "Architecture": "Arhitektūra",
    "Construction": "Būvniecība",
    "Consulting - IT, software": "Konsultācijas - IT, programmatūra",
    "Consulting - Management": "Konsultācijas – vadība",
    "Finance": "Finanses",
    "Legal": "Juridisks",
    "Medicine / Pharmacy ": "Medicīna / Farmācija ",
    "Non-profit": "Bezpeļņas organizācija",
    "Web design": "Tīmekļa vietņu dizains",
    "Web development": "Tīmekļa vietņu izstrāde",
    "Max 140 characters": "Maksimāli 140 rakstzīmes",
    "Please complete the checklist": "Lūdzu, aizpildiet kontrolsarakstu",
    "It is required to mark all checklist items as done": "Visi kontrolsaraksta vienumi ir jāatzīmē kā izpildīti",
    "Please enter time spent": "Lūdzu, ievadiet pavadīto laiku",
    "Inserting time is essential for this client": "Ievietošanas laiks šim klientam ir būtisks",
    "Only me": "Tikai es",
    "Private": "Privāts",
    "Edit note": "Rediģēt piezīmi",
    "Add additional information about the client, such as special agreements, passwords, etc.": "Pievienojiet papildu informāciju par klientu, piemēram, īpašus līgumus, paroles utt.",
    "Edit": "Rediģēt",
    "Workdays": "Darba dienas",
    "Workhours": "Darba stundas",
    "Weeks": "Nedēļas",
    "Clear filters": "Notīrīt filtrus",
    "Save filters": "Saglabāt filtrus",
    "Expected": "Paredzams",
    "Estimation": "Novērtējums",
    "Do you also want to postpone the due date?": "Vai arī vēlaties pārcelt izpildes datumu?",
    "{0} week": "{0} week",
    "{0} weeks": "{0} nedēļas",
    "Vacations": "Brīvdienas",
    "Holidays": "Brīvdienas",
    "Tax dates": "Nodokļu datumi",
    "Accounting news": "Grāmatvedības jaunumi",
    "Company events": "Uzņēmuma pasākumi",
    "Member birthdays": "Dalībnieku dzimšanas dienas",
    "Contact birthdays": "Sazinieties ar dzimšanas dienas",
    "Group items": "Grupas vienumi",
    "Don't group": "Negrupējiet",
    "{0} away": "{0} prom",
    "Member birthday | Member birthdays": "Dalībnieku dzimšanas dienas | Dalībnieku dzimšanas dienas",
    "Contact birthday | Contact birthdays": "Kontaktpersonas dzimšanas diena | Kontaktpersonas dzimšanas dienas",
    "Contact birthday": "Kontaktpersonas dzimšanas diena",
    "Member birthday": "Dalībnieka dzimšanas diena",
    "Are you sure you wish to delete this link?": "Vai tiešām vēlaties dzēst šo saiti?",
    "Reference name": "Atsauces nosaukums",
    "Reference link": "Atsauces saite",
    "Free trial": "Bezmaksas izmēģinājuma versija",
    "Solo": "Vienatnē",
    "Team": "Komanda",
    "Enterprise": "Uzņēmums",
    "Mini Uku": "Mini Uku",
    "Chrome browser plugin for Uku to manage your task, clients and track time.": "Chrome pārlūkprogrammas spraudnis Uku, lai pārvaldītu jūsu uzdevumu, klientus un izsekotu laiku.",
    "Setup task/job plans to automate your workflow, add topics, custom fields and modify your preferences.": "Iestatiet uzdevumu/darba plānus, lai automatizētu darbplūsmu, pievienotu tēmas, pielāgotus laukus un mainītu preferences.",
    "Setup client groups, custom fields and modify your preferences.": "Iestatiet klientu grupas, pielāgotus laukus un mainiet savas preferences.",
    "test": "pārbaude",
    "Anti Money Laundering": "Pret naudas atmazgāšanu",
    "Setup your customer AML and get instant reminders when auditing is due.": "Iestatiet klienta AML un saņemiet tūlītējus atgādinājumus, kad jāveic audits.",
    "flextime_description": "ērti pārvaldiet darba un privātās dzīves līdzsvaru",
    "Smart Accounts": "Viedie konti",
    "Automatically imports work statistics from your accounting software.": "Automātiski importē darba statistiku no jūsu grāmatvedības programmatūras.",
    "Merit Aktiva": "Merit Active",
    "360 Księgowość": "360 Grāmatvedība",
    "Speed up your client billing process with pricelists and smart contracts.": "Paātriniet klienta rēķini procesu, izmantojot cenu sarakstus un viedos līgumus.",
    "Visual report will tell you exactly how profitable or unprofitable your client is.": "Vizuālais pārskats precīzi parādīs, cik rentabls vai nerentabls ir jūsu klients.",
    "Emailing description": "Apraksts e-pastā",
    "e-conomic": "e-conomic",
    "Sync client data from Uku to e-conomic and vice versa. View sales ledger information for each client.": "Sinhronizējiet klienta datus no Uku uz e-conomic un otrādi. Skatiet pārdošanas virsgrāmatas informāciju par katru klientu.",
    "Xero": "Xero",
    "xero_description": "xero_description",
    "QuickBooks": "QuickBooks",
    "quickbooks_description": "quickbooks_description",
    "Tripletex": "Tripletex",
    "tripletex_description": "tripletex_description",
    "Scoro": "Scoro",
    "Export sales invoices.": "Eksportēt pārdošanas rēķinus.",
    "Fortnox": "Fortnox",
    "fortnox_description": "fortnox_description",
    "Magic button": "Burvju poga",
    "With one click - a quick and easy way to create important tasks. For example, a phone call from a client.": "Ar vienu klikšķi – ātrs un vienkāršs veids, kā izveidot svarīgus uzdevumus. Piemēram, tālruņa zvans no klienta.",
    "With suppliers, you make your projects and partners management more efficient.": "Izmantojot piegādātājus, jūs padarāt savus projektus un partneru pārvaldību efektīvāku.",
    "Powerful and flexible project management serves diverse use cases and workflows.": "Jaudīga un elastīga projektu vadība kalpo dažādiem lietošanas gadījumiem un darbplūsmām.",
    "client_portal_app_description": "klientu portāls vienkāršo sadarbību ar klientiem. Droši saņemiet dokumentēt, dot uzdevumus un kopīgot informāciju",
    "Chat": "Tērzēšana",
    "chat_app_description": "uzlabojiet komandas sadarbību, klientu komunikāciju un vispārējo efektivitāti ar tērzēšanu",
    "Companies House": "Uzņēmumu nams",
    "companies_house_app_description": "Lielbritānijas uzņēmējdarbības reģistra integrācija",
    "documents_app_description": "documents_app_description",
    "Connect and discover tools to help you manage your business.": "Izveidojiet savienojumu un atklājiet rīkus, kas palīdzēs pārvaldīt jūsu uzņēmumu.",
    "Subscribe now": "Abonēt tagad",
    "Compare plans": "Salīdziniet plānus",
    "Add company": "Pievienojiet uzņēmumu",
    "BETA": "BETA",
    "Setup": "Uzstādīt",
    "Power up": "Ieslēgt",
    "Integrations": "Integrācijas",
    "Hi! Do you want to work with a team and use extra features? No problem, first add your company!": "Sveiki! Vai vēlaties strādāt komandā un izmantot papildu funkcijas? Nekādu problēmu, vispirms pievienojiet savu uzņēmumu!",
    "Read more about Uku plans": "Lasiet vairāk par Uku plāniem",
    "Contact role": "Kontaktpersonas loma",
    "Contact roles": "Kontaktpersonas lomas",
    "Client groups": "Klientu grupas",
    "Client fields": "Klientu lauki",
    "Contact fields": "Kontaktu lauki",
    "View archive": "Skatīt arhīvu",
    "Restore from archive": "Atjaunot no arhīva",
    "Empty list": "Tukšs saraksts",
    "Task fields": "Uzdevumu lauki",
    "task topics": "uzdevumu tēmas",
    "Keep the task opened when starting the timer": "Palaižot taimeri, turiet uzdevumu atvērtu",
    "task templates": "uzdevumu veidnes",
    "Author": "Autors",
    "Duplicate": "Dublikāts",
    "Uku task templates": "Uku uzdevumu veidnes",
    "Are you sure that you want to delete this task template?": "Vai tiešām vēlaties dzēst šo uzdevuma veidni?",
    "Templates": "Veidnes",
    "Overview": "Pārskats",
    "chat_app_overview_text": "<p class='title'>Uku Chat ir lietotājam draudzīgs un drošs ziņojumapmaiņas rīks, kas pielāgots saziņas, sadarbības un uzdevumu pārvaldības pilnveidošanai.</p> <div class='body-2'><p>Galvenās funkcijas ietver :</p><ul><li>Reāllaika ziņojumapmaiņa: Sūtiet tūlītējos ziņojumus komandas locekļiem un klientiem. Tajā ir iespējas tiešajiem ziņojumiem, grupu tērzēšanai un īpašiem kanāliem noteiktām tēmām.</li><li>Uzdevumu pārvaldība: izveidojiet jaunu uzdevumu no sarunas.</li><li>ChatGPT integrācija: apkopojiet sarunu, mainiet balss toni un pieprasiet ieteikumus atbildei.</li><li>Pielāgojami paziņojumi: pielāgojiet paziņojumus savām vēlmēm.</li></ul></div>",
    "Color": "Krāsa",
    "Are you sure to delete this field? You may lose the data.": "Vai tiešām dzēsīsit šo lauku? Jūs varat zaudēt datus.",
    "Add field": "Pievienot lauku",
    "Add section": "Pievienot sadaļu",
    "multiline": "daudzrindu",
    "Import data": "Importēt datus",
    "Automate data collection with Smart Accounts": "Automatizējiet datu vākšanu, izmantojot viedos kontus",
    "<ul><li>Import purchase and sales entries, total entries and entry lines count;</li><li>Automate data collection with Smart Accounts;</li><li>Faster & more accurate billing through automated data exchange. Uku gathers information for preparing customers' invoices in one place and makes invoicing efficient.</li></ul>": "<ul><li>Importējiet pirkšanas un pārdošanas ierakstus, kopējo ierakstu un ierakstu rindu skaitu;</li><li>automatizējiet datu vākšanu, izmantojot viedos kontus;</li><li>ātrāk un precīzāki rēķini, izmantojot automatizētu datu apmaiņu. Uku apkopo informāciju klientu rēķinu sagatavošanai vienuviet un padara rēķinu izrakstīšanu efektīvu.</li></ul>",
    "xero_app_overview_text": "<p class='title'>Automatizējiet rēķini procesu, savienojot Xero ar Uku.</p> <div class='body-2'><p>Xero integrācijas priekšrocības:</p><ul><li >Importējiet visus savus klientus no Xero uz Uku, veicot tikai dažus klikšķus</li><li>Importējiet produktu kodus un klasifikatorus uz Uku</li><li>Automātiski izveidojiet rēķinus Uku un nosūtiet tos uz Xero.</li> </ul></div>",
    "Import clients from {0}": "Importēt klientus no {0}",
    "Before importing clients, you need to authorize with Xero and select the Company.": "Pirms klientu importēšanas jums ir jāautorizējas ar Xero un jāizvēlas uzņēmums.",
    "Authorize Xero to start import": "Pilnvarojiet Xero, lai sāktu importēšanu",
    "Failed to import clients": "Neizdevās importēt klientus",
    "Failed to connect to WS": "Neizdevās izveidot savienojumu ar WS",
    "Import": "Importēt",
    "emailing_app_overview_text": "<p class='title'><b>Ātra un ērta saziņa ar klientiem</b></p><div class='body-2'><p>Sūtiet vienreizējus e-pasta ziņojumus vai iestatiet automātiskus e-pasta ziņojumus. Varat veikt abus uzdevumu skatā.</p><p><b>Automatizēti e-pasta ziņojumi</b></p><p>Pievienojiet automātisku e-pasta ziņojumu periodiskiem uzdevumiem. Piemēram, uzdevumam \"Dokumentu ievade\" iestatiet automātisku e-pasta ziņojumu \"Trūkst dokumenti\", kas tiks izsūtīts 2 dienas pirms uzdevuma sākuma. Tādā veidā jums ir visi nepieciešamie dokumenti, uzsākot darbu pie uzdevuma.</p><p><b>E-pasta veidnes</b></p><p>Saglabājiet e-pasta ziņojumus, kurus bieži sūtāt, ērti kā veidni. Tādējādi jūs ietaupīsit problēmas, kas saistītas ar nepārtrauktu viena satura ziņojumu rakstīšanu.</p></div>",
    "Email signatures": "Email signatures",
    "Everyone": "Visi",
    "Access": "Piekļuve",
    "Creator": "Radītājs",
    "Are you sure you want to delete this signature? Some emails will be affected": "Are you sure you want to delete this signature? Some emails will be affected",
    "Email addresses": "E-pasta adreses",
    "Signatures": "Signatures",
    "Send emails": "Send emails",
    "Uku securely integrates with your email to help you manage and automate communication": "Uku droši integrējas ar jūsu e-pastu, lai palīdzētu jums pārvaldīt un automatizēt saziņu",
    "Use {0} address": "Izmantojiet {0} adresi",
    "connect your email address": "pievienojiet savu e-pasta adresi",
    "Connect with Microsoft Exchange or other email server(SMTP)": "Izveidojiet savienojumu ar Microsoft Exchange vai citu e-pasta serveri (SMTP)",
    "Email integration reconnected": "Atjaunota e-pasta integrācija",
    "Are you sure you want to delete this email integration?": "Vai tiešām vēlaties dzēst šo e-pasta integrāciju?",
    "Email templates": "E-pasta veidnes",
    "Add email template": "Pievienojiet e-pasta veidni",
    "Are you sure you want to save this template? Some tasks will be affected": "Vai tiešām vēlaties saglabāt šo veidni? Tiks ietekmēti daži uzdevumi",
    "Clients can leave task messages by replying to client portal email": "Clients can leave task messages by replying to client portal email",
    "Send a copy of client's response to member's inbox": "Send a copy of client's response to member's inbox",
    "Email recipients can leave task comments by replying to a task email": "Email recipients can leave task comments by replying to a task email",
    "economic_app_overview_text": "<p class='title'>Automatizējiet rēķini procesu, savienojot e-conomic ar Uku</p><div class='body-2'><p>e-conomic integrācija ļauj:<ul><li> importējiet visus savus klientus no e-conomic uz Uku tikai ar pāris klikšķiem</li><li>importējiet produktus un klasifikatorus no e-conomic uz Uku</li><li>automātiski izveidojiet rēķinus Uku un nosūtiet tos uz e-conomic</li></ul></p></div>",
    "Default layout": "Noklusējuma izkārtojums",
    "Change agreement ID": "Mainīt līguma ID",
    "Failed to connect to server": "Neizdevās izveidot savienojumu ar serveri",
    "Uku will import all clients, clients info and classificatiors. In the final step you can select which clients you want to add or update.": "Uku importēs visus klientus, klientu informāciju un klasifikatorus. Pēdējā darbībā varat izvēlēties, kurus klientus vēlaties pievienot vai atjaunināt.",
    "Connect e-conomic": "Pievienojiet e-conomic",
    "Before importing clients, you need to connect Uku and economic software. To do this, create economic agreement and enter the agreement ID here.": "Pirms klientu importēšanas ir jāsavieno Uku un ekonomiskā programmatūra. Lai to izdarītu, izveidojiet ekonomisko līgumu un ievadiet šeit līguma ID.",
    "Step {0}": "{0}. darbība",
    "Get agreement ID": "Iegūstiet līguma ID",
    "Insert agreement ID": "Ievietojiet līguma ID",
    "Connect": "Savienot",
    "quickbooks_app_overview_text": "quickbooks_app_overview_text",
    "Uku will import all clients, clients info and classificatiors from QuickBooks. In the final step you can select which clients you want to add or update.": "Uku importēs visus klientus, klientu informāciju un klasifikatorus no QuickBooks. Pēdējā solī varat izvēlēties, kurus klientus vēlaties pievienot vai atjaunināt.",
    "Before importing clients, you need to connect with QuickBooks.": "Pirms klientu importēšanas nepieciešams izveidot savienojumu ar QuickBooks.",
    "Connected to QuickBooks": "Savienots ar QuickBooks",
    "fortnox_app_overview_text": "fortnox_app_overview_text",
    "Uku will import all clients, clients info and classificators from Fortnox. In the final step you can select which clients you want to add or update.": "Uku importēs visus klientus, klientu informāciju un klasifikatorus no Fortnox. Pēdējā solī varat izvēlēties, kurus klientus vēlaties pievienot vai atjaunināt.",
    "Before importing clients, you need to connect with Fortnox.": "Pirms klientu importēšanas ir nepieciešams izveidot savienojumu ar Fortnox.",
    "Connect to Fortnox": "Savienojums ar Fortnox",
    "Connected to Fortnox": "Savienots ar Fortnox",
    "Delete template": "Dzēst veidni",
    "Public": "Publisks",
    "Workflow templates": "Darbplūsmas veidnes",
    "No workflow templates yet": "Vēl nav nevienas darbplūsmas veidnes",
    "Modified": "Pārveidots",
    "Uku workflow templates": "Uku darba plūsmas veidnes",
    "Are you sure you wish to delete this workflow?": "Vai tiešām vēlaties dzēst šo darbplūsmu?",
    "Project fields": "Projekta lauki",
    "Progress step": "Progresa solis",
    "Rename project": "Pārdēvēt projektu",
    "Project statuses": "Projektu statusi",
    "You can use the statuses to restrict the workflow.": "Varat izmantot statusus, lai ierobežotu darbplūsmu.",
    "Project phases": "Projekta posmi",
    "Make your progress beautiful.": "Padariet savu progresu skaistu.",
    "Permissions": "Atļaujas",
    "Users can manage workflow templates": "Lietotāji var pārvaldīt darbplūsmas veidnes",
    "project_app_overview_text": "<div class=‘body-2’><p>Plan and execute tasks, track your projects, and never have a task fall through the cracks.</p><p>Key features:</p><ul><li><b>Creating projects: </b>Create projects using ready-made, customisable project templates. Keep non-accounting projects like client or employee onboarding separate from daily tasks. You can also start projects from scratch to tailor projects precisely to your needs.</li><li><b>Task management: </b>Break projects into tasks, assign responsibilities, and set due dates and dependencies. Separate extra services from daily accounting tasks.</li><li><b>Progress tracking: </b>The interactive project overview helps visualise progress, allowing for effective project schedule management. For instance, project tasks, like onboarding and off-boarding templates, look different from your regular tasks.</li><li><b>Customisation: </b>Tailor projects to your organisation’s needs with customisable fields and workflow templates. Have tasks depend on the project’s start or due date rather than a specific date of the month, providing flexibility and adaptability to project management.</li></ul></div>",
    "project_app_overview_description": "Handle projects from initiation to completion with ease.",
    "Configure summary task": "Konfigurēt kopsavilkuma uzdevumu",
    "Uku will generate task with following title and topic on the last day of the month.": "Uku ģenerēs uzdevumu ar šādu nosaukumu un tēmu mēneša pēdējā dienā.",
    "Task title": "Uzdevuma nosaukums",
    "Recurrence": "Atkārtošanās",
    "Count changes from previous periods": "Skaita izmaiņas salīdzinājumā ar iepriekšējiem periodiem",
    "If enabled, changes made to previous periods will be added to current month. If disabled, changes made to previous periods will not be accounted for.": "Ja šī opcija ir iespējota, izmaiņas, kas veiktas iepriekšējos periodos, tiks pievienotas pašreizējam mēnesim. Ja tas ir atspējots, iepriekšējos periodos veiktās izmaiņas netiks ņemtas vērā.",
    "Configure data fields": "Konfigurējiet datu laukus",
    "Select corresponding Uku field for each imported field. Same fields will be summarized. By leaving some field blank it will be ignored.": "Katram importētajam laukam atlasiet atbilstošo Uku lauku. Tie paši lauki tiks apkopoti. Atstājot kādu lauku tukšu, tas tiks ignorēts.",
    "New custom field": "Jauns pielāgots lauks",
    "Show more": "Parādīt vairāk",
    "Every month": "Katru mēnesi",
    "Last day of the month": "Mēneša pēdējā diena",
    "1": "1",
    "2": "2",
    "3": "3",
    "4": "4",
    "5": "5",
    "6": "6",
    "7": "7",
    "8": "8",
    "9": "9",
    "10": "10",
    "11": "11",
    "12": "12",
    "13": "13",
    "14": "14",
    "15": "15",
    "16": "16",
    "17": "17",
    "18": "18",
    "19": "19",
    "20": "20",
    "21": "21",
    "22": "22",
    "23": "23",
    "24": "24",
    "25": "25",
    "26": "26",
    "27": "27",
    "28": "28",
    "Day {0} of next month": "Nākamā mēneša {0}. diena",
    "Settings saved": "Iestatījumi saglabāti",
    "Uku will let you know when it is ready.": "Uku jūs informēs, kad tas būs gatavs.",
    "Reload data": "Pārlādēt datus",
    "months": "mēneši",
    "This will overwrite existing summary tasks new values.": "Tas pārraksta esošās kopsavilkuma uzdevumu jaunās vērtības.",
    "Overwrite": "Pārrakstīt",
    "Automate your anti money laundering process": "Automatizējiet savu nelikumīgi iegūtu līdzekļu legalizācijas novēršanas procesu",
    "You are about to activate anti money laundering process. During that new additional fields will be added to your clients data and also system will start reminding you about updating them.<br><br>Additional fields are:<ul><li>Risk profile</il><li>Profile valid until</il><li>AML Staus</il><li>Document NO</il><li>Document valid until</li></ul>": "Jūs gatavojaties aktivizēt nelikumīgi iegūtu līdzekļu legalizācijas novēršanas procesu. Tā laikā jūsu klientu datiem tiks pievienoti jauni papildu lauki, kā arī sistēma sāks atgādināt par to atjaunināšanu.<br><br>Papildu lauki ir:<ul><li>Riska profils</il><li>Profils derīgs līdz</il><li>AML statuss</il><li>Dokuments NĒ</il><li>Dokuments derīgs līdz</li></ul>",
    "You are about to activate anti money laundering process. During that new additional fields will be added to your clients data and also system will start reminding you about updating them.<br><br>Additional fields are:<ul><li>Risk profile</il><li>Next AML check</il><li>Pass/Fail</il><li>ID type</il><li>ID Number</il><li>Date of expiry</il><li>Additional checks</li></ul>": "Jūs gatavojaties aktivizēt nelikumīgi iegūtu līdzekļu legalizācijas novēršanas procesu. Tā laikā jūsu klientu datiem tiks pievienoti jauni papildu lauki, kā arī sistēma sāks atgādināt par to atjaunināšanu.<br><br>Papildu lauki ir:<ul><li>Riska profils</il><li>Nākamais AML pārbaude</il><li>Apstiprināta/neatbilstoša</il><li>ID veids</il><li>ID numurs</il><li>Derīguma beigu datums</il><li>Papildu pārbaudes</il><li> li></ul>",
    "Do not change client custom fields created by Uku": "Nemainiet Uku izveidotos klienta pielāgotos laukus",
    "day(s) before": "diena(s) iepriekš",
    "Task name": "Uzdevuma nosaukums",
    "Assigned": "Piešķirts",
    "Note": "Piezīme",
    "Manual run": "Manuāla palaišana",
    "Create a task when the document expires": "Izveidojiet uzdevumu, kad beidzas dokumenta derīguma termiņš",
    "Create a task when the risk profile must be updated": "Izveidojiet uzdevumu, kad ir jāatjaunina riska profils",
    "Flextime period": "Flextime periods",
    "Confirmation period": "Confirmation period",
    "Weekly": "Iknedēļas",
    "Add agreement": "Pievienojiet vienošanos",
    "flextime_app_overview_text": "<p class='title'>Saņemiet pārskatu par savas komandas darba stundām, virsstundām un atvaļinājuma atlikumu.</p> <div class='body-2'><p></p><p>Elastīga laika priekšrocības: </p><ul><li>Ērts pārskats par darbu un virsstundām</li><li>Pieejama atvaļinājumu pārvaldība un bilances pārskats</li><li>Vienkārša datu eksportēšana jūsu grāmatvedim</li></ul> </div>",
    "supplier_app_overview_text": "supplier_app_overview_text",
    "supplier_app_overview_description": "supplier_app_overview_description",
    "Supplier type": "Piegādātāja veids",
    "Parent type": "Vecāku tips",
    "Edit supplier type": "Rediģēt piegādātāja veidu",
    "New supplier type": "Jauns piegādātāja veids",
    "Are you sure you wish to delete this supplier type?": "Vai tiešām vēlaties dzēst šo piegādātāja veidu?",
    "Types": "Veidi",
    "Supplier types": "Piegādātāju veidi",
    "No supplier types yet": "Pagaidām nav piegādātāju veidu",
    "tripletex_app_overview_text": "tripletex_app_overview_text",
    "Uku will import all clients, clients info and classificators from Tripletex. In the final step you can select which clients you want to add or update.": "Uku importēs visus klientus, klientu informāciju un klasifikatorus no Tripletex. Pēdējā solī varat izvēlēties, kurus klientus vēlaties pievienot vai atjaunināt.",
    "Connect Tripletex": "Savienot Tripletex",
    "Before importing clients, you need to connect Uku and Tripletex software. To do this, create employee token and enter it here.": "Pirms klientu importēšanas ir nepieciešams savienot Uku un Tripletex programmatūru. Lai to izdarītu, izveidojiet darbinieka žetonu un ievadiet to šeit.",
    "Get employee token": "Iegūt darbinieka žetonu",
    "Insert employee token": "Ievietot darbinieka žetonu",
    "Install": "Uzstādīt",
    "Open Chrome browser to install": "Lai instalētu, atveriet pārlūkprogrammu Chrome",
    "Works with your online accounting software.": "Darbojas ar jūsu tiešsaistes grāmatvedības programmatūru.",
    "New tasks can strike like lightning and that’s why Mini Uku is your best friend. No matter whether you’re making bank transfers or working in your accounting software; with Mini Uku you can add new tasks, track time and keep on top of all your notifications from any website.<br><br>Just one click on the owl icon provides an overview of your entire working day and helps you plan your schedule more efficiently.": "Jauni uzdevumi var parādīties kā zibens no skaidrām debesīm, tāpēc Mini Uku ir jūsu labākais draugs. Neatkarīgi no tā, vai veicat bankas pārskaitījumus vai strādājat savā grāmatvedības programmā; ar Mini Uku varat pievienot jaunus uzdevumus, izsekot laiku un sekot līdzi visiem saviem paziņojumiem no jebkuras vietnes.<br><br>Vienkārši viens klikšķis uz pūces ikonas sniedz pārskatu par visu jūsu darba dienu un palīdz plānot savu grafiku. efektīvāk.",
    "merit_aktiva_app_overview_text_pl": "merit_aktiva_app_overview_text_pl",
    "merit_aktiva_app_overview_text": "<p class='title'>Importējiet klientus un darba apjomu, lai iegūtu vienu pārskatu ar paveiktā darba datiem par visiem klientiem.</p><div class='body-2'><p>Padariet savu datu vākšanu ātri. un precīzi ar Merit Aktiva un Uku integrāciju. Uku automātiski importē pārdošanas un pirkšanas rēķinus, dokumentus, ierakstus utt. katram klientam un veic darba apjomu un laika ierakstus vienā interaktīvā atskaitē. Jums vairs nav jāpārslēdzas starp klientiem grāmatvedības programmatūrā, lai iegūtu informāciju par dokumentiem, kas apstrādāti, lai izveidotu rēķinus vai pārraudzītu klienta darbību. Salīdzinot ar Merit, Uku importē pēdējo mēneša faktisko ierakstu apjomu, ņemot vērā visas izmaiņas, kas tika ievietotas iepriekšējos periodos. Tas nozīmē, ka jums nav jāatceras vai jāpieraksta nekādas veiktās izmaiņas — Uku rīcībā ir visa šī informācija, un jums tāpat. Automatizēta datu vākšana ietaupa jūsu laiku un novērš cilvēku kļūdas.</p><p>Uku un Merit Aktiva integrācija palīdz:</p><p><ul><li>Ātri un precīzi apkopot datus – darba apjoms ir lielāks automātiski importēts uz Uku no Merit</li><li>Analizējiet darba slodzi un laiku, iegūstot pilnu pārskatu par paveikto darbu un klientiem pavadīto laiku.</li><li>Automatizējiet ikmēneša kopsavilkumu izveidi </li><li> Iegūstiet pārskatu par faktisko darba slodzi katru mēnesi.</li></ul></p><p>Izmantojot Uku — Merit integrāciju, varat importēt šādu apjomu:</p><p><ul><li>Dokumenti </li><li>Ieraksti</li><li>Pārdošanas rēķini</li><li>Pirkumu rēķini</li><li>Bankas ieraksti</li><li>Kases ieraksti</li><li >PVN ieraksti</li><li>Krājumu ieraksti</li><li>u.c.</li></ul></p></div>",
    "Import clients": "Importēt klientus",
    "documents_app_overview_text": "documents_app_overview_text",
    "Connect your existing document management system": "Connect your existing document management system",
    "Main folder": "Main folder",
    "Under this folder, Uku automatically creates folders for each client.": "Under this folder, Uku automatically creates folders for each client.",
    "You can customize each client folder separately under client settings.": "You can customize each client folder separately under client settings.",
    "Automatically create Public folder for client files and Private folder for member files": "Automatically create Public folder for client files and Private folder for member files",
    "Automatically create  Year / Month subfolder under each client for files sorting": "Automatically create  Year / Month subfolder under each client for files sorting",
    "Automatically create  Notes and Templates subfolders under each client for files sorting": "Automatically create  Notes and Templates subfolders under each client for files sorting",
    "Add task files added by Members": "Add task files added by Members",
    "Add task files added by Clients (from emails and client portal)": "Add task files added by Clients (from emails and client portal)",
    "Backup files to Uku file storage": "Backup files to Uku file storage",
    "Perfect example": "Perfect example",
    "You are about to disconnect this service.": "You are about to disconnect this service.",
    "Google Drive": "Google Drive",
    "OneDrive": "OneDrive",
    "Select folder": "Select folder",
    "Manage": "Manage",
    "Refresh": "Atjaunot",
    "Be aware of the issues before they become problems": "Apzinieties problēmas, pirms tās kļūst par problēmām",
    "<ul><li>Real time comparison of client contract and actual work done;</li><li>Be aware of the issues before they become problems;</li><li>Even with fixed prices you need to have internal measurements. Monitor the validity of the client’s agreement by comparing it with the actual amount of work done.</li></ul>": "<ul><li>Klienta līguma un faktiskā paveiktā darba salīdzinājums reāllaikā;</li><li>Apzinieties problēmas, pirms tās kļūst par problēmām;</li><li>Pat ar fiksētām cenām jums ir jābūt iekšējai mērījumi. Sekojiet līdzi klienta līguma spēkā esamībai, salīdzinot to ar faktisko paveiktā darba apjomu.</li></ul>",
    "client_portal_app_overview_text": "<div class='body-2'><p>Uku's Client Portal improves your service by simplifying communication between accountants and clients. With Uku's Client Portal, you can speed up communication, reduce email dependency, and offer a secure document-sharing and communication platform.</p><img style='margin-bottom: 12px; width: 100%' src='/static/img/client-portal-app-description-img.png'><p>Client Portals features include:</p><ul><li><b>Magic Links:</b> Client's hassle-free login without usernames and passwords.</li><li><b>Document Digitisation:</b> Submit items to your accounting software with one click.</li><li><b>Client Communication:</b> Assign tasks to clients and send messages fast.</li><li><b>Automatic Reminders:</b> Reduce the amount of manual follow-ups, check statuses: seen, done.</li><li><b>Multilingual Interface:</b> Supports multiple languages for a personalised experience.</li><li><b>Customisable Branding:</b> Add logos, icons, colours and a welcome video to make your clients feel at home.</li></ul><p></p><p>Some Client Portal use cases:</p><p><b>1. Get Client Information:</b></p><ul><li>Add recurring tasks with document requirements.</li><li>The client gets an email and reminder with magic link to the Client Portal.</li><li>Clients upload documents and answer queries in the Client Portal.</li></ul><p></p><p><b>2. Make Finance Reviews:</b></p><ul><li>Add monthly recurring tasks with meeting links.</li><li>The client gets an email and reminder with magic link to the Client Portal.</li><li>Send the client a meeting memo with a recorded video.</li></ul><p></p><p><b>3. Onboard Your Client:</b></p><ul><li>Add an onboarding task from the template.</li><li>The client gets an email and reminder with magic link to the Client Portal.</li><li>The client fills out the checklist (accesses, reports).</li></ul><p></p><p>These use cases demonstrate Uku's Client Portal's task management and communication efficiency.</p><p><a href='https://getuku.com/client-portal' target='_blank'>Read more &rsaquo;</a></p></div>",
    "Branding": "Zīmolvedība",
    "Subdomain": "Apakšdomēns",
    "Default language": "Noklusējuma valoda",
    "Client portal URL in other languages": "Klienta portāla URL citās valodās",
    "Copy URL": "URL kopēšana",
    "Trademark": "Preču zīme",
    "Trademark text color": "Preču zīmes teksta krāsa",
    "Choose color": "Izvēlieties krāsu",
    "Brand background color": "Zīmola fona krāsa",
    "Logo": "Logotips",
    "Delete logo": "Dzēst logotipu",
    "Upload logo file": "Augšupielādēt logotipa failu",
    "Max. dimensions 180 x 60 px": "Maksimālie izmēri 180 x 60 px",
    "Favicon": "Favicon",
    "Delete icon": "Dzēst ikonu",
    "Upload icon file": "Ikonas faila augšupielāde",
    "Recommended size 260 x 260 px": "Ieteicamais izmērs 260 x 260 px",
    "Company description": "Uzņēmuma apraksts",
    "Displayed on the login page.": "Rādīts pieteikšanās lapā.",
    "Describe here what services you offer and how you help your clients.": "Aprakstiet, kādus pakalpojumus piedāvājat un kā palīdzat saviem klientiem.",
    "Welcome video": "Apsveikuma video",
    "Displayed on the login page when your client contact enters for the first time": "Rādīts pieteikšanās lapā, kad jūsu klienta kontaktpersona pirmo reizi ieiet",
    "Use Uku video": "Izmantojiet Uku video",
    "View": "Skatīt",
    "Use other video": "Izmantot citu videoklipu",
    "Youtube or Vimeo video URL": "Youtube vai Vimeo video URL",
    "Show file upload box for client tasks": "Rādīt failu augšupielādes lodziņu klienta uzdevumiem",
    "Invalid data": "Nederīgi dati",
    "Client portal preview": "Klientu portāla priekšskatījums",
    "Client portal URL for {0} copied to clipboard": "{0} klienta portāla URL kopēts uz starpliktuvi",
    "Personalize your client portal's menu": "Personalize your client portal's menu",
    "Menu links saved": "Menu links saved",
    "Add custom links to essential items such as: Documents, Financial reports, Onboarding forms, Feedback surveys, Service agreements, Pricing, Instructions, Invoices. This section allows you to build the menu structure, set the order of items, and define default links. You can also customize names and links for each client individually. Only menus with defined links are displayed in client portal. <a href='/api/help_link/cp_menu_links' target='_blank'>Read more ›</a>": "Add custom links to essential items such as: Documents, Financial reports, Onboarding forms, Feedback surveys, Service agreements, Pricing, Instructions, Invoices. This section allows you to build the menu structure, set the order of items, and define default links. You can also customize names and links for each client individually. Only menus with defined links are displayed in client portal. <a href='/api/help_link/cp_menu_links' target='_blank'>Read more ›</a>",
    "Menu links": "Menu links",
    "Add recurring task": "Pievienojiet atkārtotu uzdevumu",
    "Reminder tasks updated": "Atgādinājuma uzdevumu atjaunināšana",
    "Create recurring tasks for Companies House clients.": "Izveidojiet atkārtotus uzdevumus Uzņēmumu nama klientiem.",
    "companies_house_app_overview_text": "companies_house_app_overview_text",
    "buttons": "pogas",
    "Show to me": "Parādi man",
    "magic_button_app_overview_text": "<p class='title'>Ar vienu klikšķi pievienojiet jaunu uzdevumu un palaidiet taimeri.</p> <div class='body-2'><p>Burvju pogas ļauj ievietot steidzamu darbu (tālruņa zvanu, e-pasts) ērti.</p><p>Nekavējoties ievietojiet visus uzdevumus Uku</p><p>Maģiskās pogas ļauj ērti pievienot Uku steidzamus uzdevumus (tālruņa zvanu, e-pastu). Tas nodrošina, ka uzdevumi tiek pareizi ievietoti Uku.</p><p>Burvju pogas:</p><ul><li>ievietojiet jaunu uzdevumu un palaidiet taimeri ar vienu klikšķi (virzieties uz + pogu galvenē). </li><li>Pielāgojiet burvju pogas atbilstoši savām vajadzībām.</li><li>Pēc tam mainiet klienta vai citu informāciju.</li><li>Turpiniet ar iepriekšējo uzdevumu, kuram varat ātri piekļūt no burvju rīka. pogu saraksts.</li></ul></div>",
    "Buttons": "Pogas",
    "Member rights": "Dalībnieku tiesības",
    "Allow managers to view and create their client contracts and invoices": "Ļaujiet vadītājiem skatīt un izveidot klientu līgumus un rēķinus",
    "Allow members to view and create their client invoices": "Ļaujiet dalībniekiem skatīt un izveidot klientu rēķinus",
    "Allow members to view their client invoices": "Ļaujiet dalībniekiem skatīt savu klientu rēķinus",
    "Allow only owners to add and update products": "Atļaut tikai īpašniekiem pievienot un atjaunināt produktus",
    "Allow members to send invoices to clients": "Allow members to send invoices to clients",
    "Allow members to confirm their client invoice rows": "Ļaujiet dalībniekiem apstiprināt savas klienta rēķina rindas",
    "Send PDF invoice": "Sūtīt PDF rēķinu",
    "Invoice email": "Rēķina e-pasts",
    "Default rounding": "Noklusējuma noapaļošana",
    "Round all times up to x": "Noapaļojiet visus laikus līdz x",
    "Time rounding increment": "Laika noapaļošanas inkrements",
    "Apply time rounding to": "Piemērot laika noapaļošanu",
    "Default configuration": "Noklusējuma konfigurācija",
    "Invoice date": "Rēķina datums",
    "Invoice entry date": "Rēķina ievadīšanas datums",
    "Bill tracked time by": "Bill sekoja līdzi laikam",
    "Bill task field by": "Rēķina uzdevuma lauks pēc",
    "Create one invoice merging invoices from the same period": "Izveidot vienu rēķinu, apvienojot viena perioda rēķinus",
    "Invoices from the same period": "Tā paša perioda rēķini",
    "Hide zero sum lines": "Paslēpt nulles summas līnijas",
    "By default, time entry is billable": "Pēc noklusējuma laika ieraksts ir apmaksājams",
    "Invoice number": "Rēķina numurs",
    "Prefix": "Priedēklis",
    "Suffix": "Sufikss",
    "Google Gmail": "Google Gmail",
    "Microsoft Outlook": "Microsoft Outlook",
    "Billing settings saved": "Rēķini iestatījumi ir saglabāti",
    "billing_app_overview_text": "<p class='title'>Speed up your client billing process with flexible price lists and smart contracts.</p><div class='body-2'><p>Automate your invoicing process and save valuable time from generating invoices. Uku dynamic billing creates all your invoices based on the work done and helps you to earn fair profit from your clients. No more data collection from different softwares or excel sheets - Uku has it all and puts together invoices for you. All left for you to do is scan through the invoices and send them out.</p><p>Uku billing:</p><p><ul><li><b>Saves time</b> by reducing administrative working hours</li><li><b>Increases revenue</b> by preparing invoices based on all work done</li><li><b>Reduces error rates / avoids incorrect invoicing</b> by minimising human intervention</li><li><b>Ensures steady revenue stream</b> with more timely billing</li><li><b>Increases transparency</b> thanks to detailed and easily accessible customer agreements</li><li><b>Increases accuracy</b> by remembering all contract changes from day 1</li><li><b>Allows flexibility, scalability</b> and provides better customer experience for your client</li></ul></p><p>Uku supports all kinds of pricing models - whatever agreements you have made with your clients, we got your back. Uku invoicing allows you to create products including:</p><p><ul><li>Hourly pricing (e.g accountant price, assistant price)</li><li>Fixed fee pricing (e.g packages, annually agreed price)</li><li>Value based pricing (e.g perceived value of service(s))</li><li>Volume of work based pricing (e.g amount of documents processed)</li><li>Additional services pricing (e.g annual accounts, consultation)</li><li>Combination of several models (e.g fixed fee pricing + extra hours worked; volume of work + consultation hours; etc.)</li></ul></p><p>After the invoices have been created by Uku, you can review them, make changes (if necessary) and send them all out in bulk.</p><p><a href='http://help.getuku.com/en/articles/5716548-how-does-billing-work-in-uku' taget='_blank'>Learn more about Uku billing here.</a> </p><p>If you want to implement Uku billing and would like to have a consultation with our expert, please <a href='https://calendly.com/getuku/uku-billing' target='_blank'>book a time here</a> (free of charge).</p></div>",
    "Products": "Produkti",
    "Contract templates": "Līgumu veidnes",
    "Invoice templates": "Rēķinu veidnes",
    "Tools": "Rīki",
    "Replace tax": "Nodokļa aizstāšana",
    "Old tax": "Vecie nodokļi",
    "New tax": "Jauni nodokļi",
    "Find tax": "Atrast nodokļus",
    "Replace VAT in products": "Aizstāt PVN precēm",
    "Replace VAT in master contracts": "Līguma veidnēs aizstāt PVN",
    "Replace VAT in client contracts & draft invoices": "Aizstāt PVN klientu līgumos un rēķinu projektos",
    "Replace VAT values": "Aizstāt PVN vērtības",
    "This action cannot be undone": "Šo darbību nevar atsaukt",
    "Replace": "Aizvietot",
    "Result": "Rezultāts",
    "PDF templates": "PDF veidnes",
    "E-mail templates": "E-pasta veidnes",
    "Edit PDF template": "Rediģēt PDF veidni",
    "Import classificators": "Importēt klasifikatorus",
    "products": "produkti",
    "product": "produkts",
    "Product / service": "Produkts/pakalpojums",
    "Calculate": "Aprēķināt",
    "Article": "Artikls",
    "Resource": "Resurss",
    "Cost center": "Izmaksu centrs",
    "Taxes": "Nodokļi",
    "Code": "Kods",
    "Source": "Avots",
    "Articles": "Ziņas",
    "Resources": "Resursi",
    "Cost centers": "Izmaksu centri",
    "Units": "Vienības",
    "Unit": "Vienība",
    "Bank accounts": "Bankas konti",
    "Bank account": "Bankas konts",
    "Bank name": "Bankas nosaukums",
    "IBAN": "IBAN",
    "SWIFT code": "SWIFT kods",
    "Do you wish to import only new data or also overwrite existing?": "Vai vēlaties importēt tikai jaunus datus vai arī pārrakstīt esošos?",
    "Only new": "Tikai jauni",
    "New items will be added. Existing ones will remain unchanged by import.": "Tiks pievienoti jauni priekšmeti. Importējot esošās preces paliks nemainīgas.",
    "Import everything": "Importēt visu",
    "Connect accounting service": "Pievienojiet grāmatvedības pakalpojumu",
    "Service": "Apkalpošana",
    "API ID": "API ID",
    "API key": "API atslēga",
    "Company Account Id": "Uzņēmuma konta ID",
    "Api secret": "Api noslēpums",
    "E-conomic": "Ekonomisks",
    "SmartAccounts": "Viedie konti",
    "Test": "Pārbaude",
    "Lock time entries": "Bloķēt laika ierakstus",
    "Owner rights": "Īpašnieka tiesības",
    "Disable company settings edit for all members": "Aizliegt uzņēmuma iestatījumu rediģēšanu visiem dalībniekiem",
    "Disable personal clients for members": "Personīgo klientu atspējošana biedriem",
    "Show member birthdays": "Rādīt biedru dzimšanas dienas",
    "Show contact birthdays": "Rādīt kontaktpersonu dzimšanas dienas",
    "Weekly @ Sun {0}": "Katru nedēļu svētdien, {0}",
    "Monthly @ last day of month": "Ik mēnesi @ mēneša pēdējā diena",
    "Company event list": "Uzņēmuma pasākumu saraksts",
    "How long?": "Cik ilgi?",
    "Invoice no.": "Rēķins Nr.",
    "Login options": "Pieteikšanās iespējas",
    "Tenant ID (optional)": "Nomnieka ID (pēc izvēles)",
    "Add Active Directory tenant ID, if only users belonging to this tenant are allowed to connect": "Pievienojiet Active Directory nomnieka ID, ja ir atļauts izveidot savienojumu tikai lietotājiem, kas pieder šim nomniekam",
    "How to find ID’s?": "Kā atrast ID?",
    "Microsoft connected": "Microsoft ir izveidojis savienojumu",
    "Google connected": "Google ir savienots",
    "Edit company": "Rediģēt uzņēmumu",
    "Timezone": "Laika zona",
    "VAT number": "PVN numurs",
    "Company number": "Reģistrācijas numurs",
    "Subscription plan": "Abonēšanas plāns",
    "Payment failed": "Maksājums neizdevās",
    "Retry payment": "Mēģiniet veikt maksājumu vēlreiz",
    "Next payment": "Nākamais maksājums",
    "Update payment method": "Atjauniniet maksājuma veidu",
    "Plan": "Plāns",
    "Choose a plan": "Izvēlieties plānu",
    "Change plan": "Mainīt plānu",
    "{0}-day free trial until {1}": "{0} - dienas bezmaksas izmēģinājuma termiņš līdz {1}",
    "monthly": "katru mēnesi",
    "yearly": "gadā",
    "{0} member": "{0} dalībnieks",
    "{0} members": "{0} dalībnieki",
    "{0} plan": "{0} plāns",
    "Cancelled (valid until {0})": "Atcelts (derīgs līdz {0})",
    "Your trial expired on {0}": "Jūsu izmēģinājuma termiņš beidzās {0}",
    "Your subscription expired on {0}": "Jūsu abonēšanas termiņš beidzās {0}",
    "It’s nice to see you! If you'd like to get up and running with a Uku subscription, click Choose a plan": "Prieks jūs redzēt! Ja vēlaties uzsākt un sākt izmantot Uku abonementu, noklikšķiniet uz Izvēlieties plānu",
    "Save {0} by paying for a year!": "Ietaupiet {0}, maksājot par gadu!",
    "Choose plan": "Izvēlieties plānu",
    "Pay annually": "Maksājiet katru gadu",
    "Instructions sent!": "Norādījumi nosūtīti!",
    "Instructions for resetting your password have been sent to": "Norādījumi paroles atiestatīšanai ir nosūtīti uz",
    "You’ll receive this email within 5 minutes. Be sure to check your spam folder, too.": "Šo e-pasta ziņojumu saņemsit 5 minūšu laikā. Noteikti pārbaudiet arī savu surogātpasta mapi.",
    "Back to login page": "Atgriezties uz pieteikšanās lapu",
    "Get new password": "Iegūstiet jaunu paroli",
    "Pick a password": "Izvēlies paroli",
    "Use minimum 8 characters with letters & numbers": "Izmantojiet vismaz 8 rakstzīmes ar burtiem un cipariem",
    "Create your Uku Account": "Izveidojiet savu Uku kontu",
    "Connect your Xero Account": "Savienojiet savu Xero kontu",
    "Phone": "Tālrunis",
    "I agree to the": "Es piekrītu",
    "Terms of Service": "Pakalpojuma noteikumi",
    "Next": "Nākamais",
    "Having trouble?": "Ir problēmas?",
    "We can help": "Mēs varam palīdzēt",
    "Log in instead": "Tā vietā piesakieties",
    "No. 1 tool for accounting practices. Automated workflows, time tracking, reports, monitoring, CRM. Get work done on time & profitably. Try for free!": "Nr.1 rīks grāmatvedības uzskaitei. Automatizētas darbplūsmas, laika uzskaite, atskaites, uzraudzība, CRM. Padariet darbu laikā un izdevīgi. Izmēģiniet bez maksas!",
    "You are invited to join": "Jūs esat aicināti pievienoties",
    "Accept invitation": "Pieņemt ielūgumu",
    "Check your email": "Pārbaudiet savu e-pastu",
    "I sent you an email with a link to activate your account. This is important to ensure the security of your account.": "Es nosūtīju jums e-pastu ar saiti, lai aktivizētu jūsu kontu. Tas ir svarīgi, lai nodrošinātu jūsu konta drošību.",
    "Go to": "Iet uz",
    "Need a new password?": "Nepieciešama jauna parole?",
    "Enter your e-mail address and we will send you directions for changing your password": "Ievadiet savu e-pasta adresi, un mēs jums nosūtīsim norādījumus paroles maiņai",
    "Send me instructions": "Nosūtiet man norādījumus",
    "Never mind, go back": "Vienalga, dodieties atpakaļ",
    "No login options enabled. Please contact the company owner": "Nav iespējotas pieteikšanās opcijas. Lūdzu, sazinieties ar uzņēmuma īpašnieku",
    "Log in to Uku": "Piesakieties Uku",
    "Forgot password?": "Aizmirsi paroli?",
    "Don't have account?": "Vai jums nav konta?",
    "Create account": "Izveidot profilu",
    "Total items:": "Vienumu kopskaits:",
    "Add new": "Pievieno jaunu",
    "Amount": "Summa",
    "Account created range": "Konts izveidots diapazons",
    "Usage limit": "Lietošanas ierobežojums",
    "Valid until": "Derīgs līdz",
    "Edit help link": "Rediģēt palīdzības saiti",
    "New help link": "Jauna palīdzības saite",
    "Name key": "Vārda atslēga",
    "Country code": "Valsts kods",
    "Period (months)": "Periods (mēneši)",
    "Account created from": "Konts izveidots no",
    "Account created until": "Konts izveidots līdz",
    "Used count": "Izmantoto skaits",
    "Sum": "Summa",
    "Create voucher": "Izveidojiet kuponu",
    "Edit voucher": "Rediģēt kuponu",
    "Are you sure to delete this voucher?": "Vai tiešām dzēsīsiet šo kuponu?",
    "row | rows": "rinda | rindas",
    "Add event": "Pievienot notikumu",
    "Are you sure you wish to delete this event?": "Vai tiešām vēlaties dzēst šo notikumu?",
    "event | events": "notikums | notikumi",
    "Security object id": "Drošības objekta id",
    "Direct rights": "Tiešas tiesības",
    "Computed rights": "Aprēķinātās tiesības",
    "Add link": "Pievienot saiti",
    "Are you sure you wish to delete this entry?": "Vai tiešām vēlaties dzēst šo ierakstu?",
    "link | links": "saite | saites",
    "Event type": "Pasākuma veids",
    "Date from": "Datums no",
    "Date until": "Datums līdz",
    "Shortened by h": "Saīsināts ar h",
    "Category": "Kategorija",
    "demo | demos": "demo | demo",
    "Companies": "Kompānijas",
    "Leads": "Vadi",
    "Demos": "Demos",
    "Vouchers": "Vaučeri",
    "KPI": "KPI",
    "Activity log": "Aktivitāšu vēsture",
    "Notifications": "Paziņojumi",
    "Me": "Es",
    "Important notifications will appear here.": "Šeit tiks parādīti svarīgi paziņojumi.",
    "Back": "Atpakaļ",
    "Return to UKU": "Atgriezties uz UKU",
    "Choose plan for {0}": "Izvēlieties plānu {0}",
    "First payment will be made after the end of the trial period.": "Pirmais maksājums tiks veikts pēc izmēģinājuma perioda beigām.",
    "Members and subscription can always be changed.": "Dalībniekus un abonementu vienmēr var mainīt.",
    "Your subscription is externally managed by Xero": "Your subscription is externally managed by Xero",
    "Select plan": "Select plan",
    "Billing period": "Rēķini periods",
    "Compare features": "Salīdziniet funkcijas",
    "Cancel uku subscription": "Atcelt Uku abonementu",
    "{0} discount": "{0} atlaides",
    "You have currently<br />{0} active member": "Jums pašlaik ir<br />{0} aktīvs dalībnieks",
    "You have currently<br />{0} active members": "Jums pašlaik ir<br />{0} aktīvi dalībnieki",
    "Select yearly plan": "Izvēlieties gada plānu",
    "Select monthly plan": "Izvēlieties mēneša plānu",
    "Attention!": "Uzmanību!",
    "If you want to use Uku for free then deactivate your account and continue with {0} plan": "Ja vēlaties izmantot Uku bez maksas, deaktivizējiet savu kontu un turpiniet ar {0} plānu",
    "per member/month (billed yearly)": "vienam dalībniekam/mēnesī (rēķins katru gadu)",
    "or {0} per member/month (monthly)": "vai {0} vienam dalībniekam mēnesī (mēnesī)",
    "Everything in {0}, plus:": "Viss mapē {0}, kā arī:",
    "Compare plans, feature-by-feature": "Salīdziniet plānus, pa vienam",
    "Deactivate account": "Deaktivizēt kontu",
    "Are you sure to deactivate {0} account?": "Vai tiešām deaktivizējat {0} kontu?",
    "If you choose to continue with freelancer plan your company account will be deactivated. Data that is related to this company will be removed.": "Ja izvēlaties turpināt izmantot ārštata plānu, jūsu uzņēmuma konts tiks deaktivizēts. Dati, kas ir saistīti ar šo uzņēmumu, tiks noņemti.",
    "Deactivate": "Deaktivizēt",
    "Teamwork": "Komandas darbs",
    "Unlimited clients + import": "Neierobežots klientu skaits + imports",
    "Access management": "Piekļuves pārvaldība",
    "Custom fields": "Pielāgoti lauki",
    "Live chat support": "Tiešraides tērzēšanas atbalsts",
    "AML": "AML",
    "API": "API",
    "Client Portal": "Klientu portāls",
    "New!": "Jaunums!",
    "Custom integrations": "Pielāgotas integrācijas",
    "Assisted clients import": "Asistētie klienti importē",
    "Tailor-made team workshop": "Pielāgota komandas darbnīca",
    "Early access to features": "Agrīna piekļuve funkcijām",
    "Pay by invoice": "Maksāt pēc rēķina",
    "Dedicated account manager": "Īpašs konta pārvaldnieks",
    "Hi! Your trial is over. Please choose {0} subscription plan to continue work": "Sveiki! Jūsu izmēģinājums ir beidzies. Lai turpinātu darbu, lūdzu, izvēlieties {0} abonēšanas plānu",
    "Hi! You need to upgrade {0} subscription plan to use that feature": "Sveiki! Lai izmantotu šo funkciju, jums ir jājaunina {0} abonēšanas plāns",
    "Waiting for the subscription to complete": "Waiting for the subscription to complete",
    "Edit VAT number": "Edit VAT number",
    "VAT": "PVN",
    "This is subscription period amount.": "Šī ir abonēšanas perioda summa.",
    "You save yearly {0}": "Jūs ietaupāt katru gadu {0}",
    "Add voucher": "Pievienot kuponu",
    "Existing credit": "Esošais kredīts",
    "Current payment": "Pašreizējais maksājums",
    "This is the current payment amount. Your bank also requires confirmation for the subscription period amount.": "Šī ir pašreizējā maksājuma summa. Jūsu banka pieprasa arī apstiprinājumu par abonēšanas perioda summu.",
    "Confirm subscription {0}": "Apstiprināt abonementu {0}",
    "Your subscription will renew on": "Jūsu abonements tiks atjaunots",
    "Thank you for believing in us!": "Paldies, ka ticat mums!",
    "Uku team": "Uku komanda",
    "Voucher {1} (-{0}%)": "Kupons {1} (-{0}%)",
    "Voucher {0}": "Kupons {0}",
    "New plan": "Jauns plāns",
    "Changed plan": "Izmainīts plāns",
    "Add {0} member": "Pievienot {0} locekli",
    "Add {0} members": "Pievienot {0} locekļus",
    "Remove {0} member": "Noņemt {0} locekli",
    "Remove {0} members": "Noņemt {0} locekļus",
    "No changes to plan": "Plānā nav izmaiņu",
    "Discount -{0}% with Yearly subscription": "Atlaide - {0}% ar gada abonementu",
    "Yearly discounted price (-{0}%)": "Gada diskontētā cena (-{0}%)",
    "Subscription updated": "Abonēšana atjaunināta",
    "Please wait": "Lūdzu uzgaidiet",
    "Your payment failed": "Jūsu maksājums neizdevās",
    "Please check that you entered the data correctly or use another card": "Lūdzu, pārbaudiet, vai pareizi ievadījāt datus, vai izmantojiet citu karti",
    "Try again": "Mēģini vēlreiz",
    "Pay": "Maksājiet",
    "Payment": "Maksājums",
    "Payment method updated": "Maksājuma metodes atjaunināšana",
    "Edit member": "Rediģēt dalībnieku",
    "First name": "Vārds",
    "Last name": "Uzvārds",
    "External ID": "Ārējais ID",
    "Select groups": "Izvēlieties grupas",
    "Administrator": "Administrators",
    "Invite sent": "Nosūtīts ielūgums",
    "Activate member": "Aktivizēt dalībnieku",
    "Deactivate member": "Deaktivizēt dalībnieku",
    "Invited": "Ielūgts",
    "Paid member": "Maksas biedrs",
    "Send an invitation": "Nosūtīt ielūgumu",
    "Limited": "Ierobežots",
    "No invite, no access": "Nav ielūguma, nav piekļuves",
    "Free until activated": "Bezmaksas līdz aktivizēšanai",
    "No access, no charge": "Nav piekļuves, nav maksas",
    "Hidden member": "Slēptais loceklis",
    "Edit members": "Rediģēt dalībniekus",
    "Select user": "Izvēlieties lietotāju",
    "Member will be assigned to every selected client": "Katram izvēlētajam klientam tiks piešķirts dalībnieks",
    "Member will be removed from all selected clients": "Dalībnieks tiks noņemts no visiem atlasītajiem klientiem",
    "Assign user": "Piešķirt lietotāju",
    "Set as primary user": "Iestatīt kā primāro lietotāju",
    "Added as a default user when adding a task plan": "Pievienots kā noklusējuma lietotājs, pievienojot uzdevumu plānu",
    "Remove from new tasks": "Noņemt no jauniem uzdevumiem",
    "Remove from plan tasks": "Noņemt uzdevumus no plāna",
    "Remove": "Noņemt",
    "Admin": "Administrators",
    "Remove user": "Noņemt lietotāju",
    "Assign to incomplete tasks": "Piešķirt nepabeigtiem uzdevumiem",
    "Reassign incomplete tasks": "Pārdodiet nepabeigtus uzdevumus",
    "Assign to plan tasks": "Uzdodiet plānot uzdevumus",
    "Reassign plan tasks": "Pārdalīt plāna uzdevumus",
    "Owner will be assigned to tasks if the removed user was the last assigned user.": "Īpašnieks tiks piešķirts uzdevumiem, ja noņemtais lietotājs bija pēdējais piešķirtais lietotājs.",
    "Run integration": "Palaidiet integrāciju",
    "Run": "Skrien",
    "Integration configuration": "Integrācijas konfigurācija",
    "Read the manual": "Izlasiet rokasgrāmatu",
    "Api key": "Api atslēga",
    "Are you sure to delete this integration info?": "Vai tiešām dzēsīsiet šo integrācijas informāciju?",
    "Edit Contracts": "Rediģēt līgumus",
    "Replace following contracts": "Aizstāt šādus līgumus",
    "Append services to following contracts": "Pievienojiet pakalpojumus šādiem līgumiem",
    "Choose template": "Izvēlieties veidni",
    "Append only": "Tikai pievienot",
    "with template": "ar veidni",
    "All existing contracts": "Visi esošie līgumi",
    "All quarterly contracts": "Visi ceturkšņa līgumi",
    "All monthly contracts": "Visi ikmēneša līgumi",
    "All yearly contracts": "Visi gada līgumi",
    "Next invoice number": "Nākamā rēķina numurs",
    "Number is too big, it cannot exceed 15 digits": "Skaitlis ir pārāk liels, tas nedrīkst pārsniegt 15 ciparus",
    "Replace topic": "Aizstāt tēmu",
    "All tasks and plans with current topic will be replaced with the new selected topic.": "Visi uzdevumi un plāni ar pašreizējo tēmu tiks aizstāti ar jauno izvēlēto tēmu.",
    "Topics replaced": "Tēmas nomainītas",
    "All tasks with the topic `{0}` will be replaced with `{1}`. This is not reversible. Are you sure?": "Visi uzdevumi ar tēmu \"{0}\" tiks aizstāti ar \"{1}\". Tas nav atgriezenisks. Vai tu esi pārliecināts?",
    "Name of topic": "Tēmas nosaukums",
    "Change topic": "Mainīt tēmu",
    "Add new topic": "Pievienot jaunu tēmu",
    "This topic is in use. Do you wish to archive it?": "Šī tēma tiek izmantota. Vai vēlaties to arhivēt?",
    "Are you sure that you want to delete this topic?": "Vai tiešām vēlaties dzēst šo tēmu?",
    "These items will be deleted permanently": "Šie vienumi tiks neatgriezeniski izdzēsti",
    "Are you sure that you want to delete this client group?": "Vai tiešām vēlaties dzēst šo klientu grupu?",
    "This client group is in use. Do you wish to archive it?": "Šī klientu grupa tiek izmantota. Vai vēlaties to arhivēt?",
    "Edit client group": "Rediģēt klientu grupu",
    "New client group": "Jauna klientu grupa",
    "Price": "Cena",
    "Quantity": "Daudzums",
    "Unit will be translated to client language": "Vienība tiks tulkota klienta valodā",
    "Pick date & time": "Izvēlieties datumu un laiku",
    "Share equally": "Dalīties vienādi",
    "Change existing": "Mainīt esošo",
    "Choose bookmark": "Izvēlieties grāmatzīmi",
    "New title": "Jauns nosaukums",
    "Set as my default view": "Lestatīt kā manu noklusējuma skatu",
    "Signature name": "Signature name",
    "Layout": "Layout",
    "Top": "Top",
    "Middle": "Middle",
    "Bottom": "Bottom",
    "Default signature": "Default signature",
    "Max. dimensions 130 x 130 px": "Max. dimensions 130 x 130 px",
    "Logo left": "Logo left",
    "Logo top": "Logo top",
    "No logo": "No logo",
    "Linkedin": "Linkedin",
    "Facebook": "Facebook",
    "Email signature": "Email signature",
    "Edit email signature": "Edit email signature",
    "Add email signature": "Add email signature",
    "Font color": "Font color",
    "Actions": "Darbības",
    "Delete signature": "Delete signature",
    "Do you wish to update related contracts and invoices?": "Vai vēlaties atjaunināt saistītos līgumus un rēķinus?",
    "Update contract templates, active contracts and open invoices.": "Atjaunināt līgumu veidnes, aktīvos līgumus un atvērtos rēķinus.",
    "The following fields will be updated": "Tālāk norādītie lauki tiks atjaunināti",
    "Custom Value": "Pielāgota vērtība",
    "This product is in use. Do you wish to archive it?": "Šis produkts tiek lietots. Vai vēlaties to arhivēt?",
    "Are you sure that you want to delete this product?": "Vai tiešām vēlaties dzēst šo produktu?",
    "Customize for client": "Pielāgojiet klientam",
    "Customize for template": "Pielāgošana veidnei",
    "Open product template": "Atvērt produkta veidni",
    "Create product template": "Izveidot produkta veidni",
    "Master template": "Galvenā veidne",
    "Client product": "Klienta produkts",
    "Client product / service": "Klienta produkts / pakalpojums",
    "New client product": "Jauns klienta produkts",
    "Template product": "Šablona produkts",
    "Template product / service": "Produkta/pakalpojuma veidne",
    "New template product": "Jauns veidnes produkts",
    "Edit translations": "Rediģēt tulkojumus",
    "Billable topics": "Rēķinu pieprasāmie temati",
    "Billable time": "Apmaksājamais laiks",
    "Minimum quantity": "Minimālais daudzums",
    "Minimum time": "Minimālais laiks",
    "Integration parameters": "Integrācijas parametri",
    "Empty values will use product default": "Tukšas vērtības izmantos produkta noklusējuma",
    "Pricing": "Cenu noteikšana",
    "DC %": "Atl. %",
    "Sum all matching rows": "Summēt visas atbilstošās rindas",
    "When enabled, total price is a cumulative sum of all matching rows. By default, total price price only uses the highest matching row.": "Ja šī opcija ir iespējota, kopējā cena ir visu atbilstošo rindu kumulatīvā summa. Pēc noklusējuma kopējā cena cena izmanto tikai lielāko atbilstošo rindu.",
    "Prices since": "Cenas kopš",
    "Add price": "Pievienot cenu",
    "Add pricing period": "Pievienojiet cenu periodu",
    "Update contracts": "Atjaunināt līgumus",
    "(Without topic)": "(bez tēmas)",
    "Fixed price": "Fiksētā cena",
    "Product": "Produkts",
    "Event created": "Izveidots notikums",
    "Project created": "Izveidots projekts",
    "Event deleted": "Pasākums dzēsts",
    "Project deleted": "Projekts dzēsts",
    "Workflow added": "Darbplūsma ir pievienota",
    "Workflow removed": "Darbplūsma noņemta",
    "Workflow updated": "Darbplūsma atjaunināta",
    "Event cancelled": "Pasākums atcelts",
    "Project cancelled": "Projekts atcelts",
    "Event reactivated": "Notikums aktivizēts no jauna",
    "Project reactivated": "Projekts aktivizēts no jauna",
    "Event archived": "Pasākums arhivēts",
    "Project archived": "Projekts arhivēts",
    "Event unarchived": "Nearhivēts notikums",
    "Project unarchived": "Projekts nav arhivēts",
    "Event changed": "Notikuma izmaiņas",
    "Project changed": "Projekta izmaiņas",
    "Event status changed: {0}": "Notikuma statusa maiņa: {0}",
    "Project status changed: {0}": "Mainīts projekta statuss: {0}",
    "Event status changed": "Notikuma statusa maiņa",
    "Project status changed": "Projekta statusa maiņa",
    "Task created": "Uzdevums izveidots",
    "Task changed": "Uzdevums mainīts",
    "Task finished": "Uzdevums pabeigts",
    "Task not finished": "Uzdevums nav pabeigts",
    "Task deleted": "Uzdevums izdzēsts",
    "Add project": "Pievienot projektu",
    "Hide filters": "Slēpt filtrus",
    "Show filters": "Rādīt filtrus",
    "Cancel event": "Atcelt notikumu",
    "Cancel project": "Atcelt projektu",
    "Manage event fields": "Notikumu lauku pārvaldība",
    "Manage project fields": "Projekta lauku pārvaldība",
    "New event": "Jauns notikums",
    "New project": "Jauns projekts",
    "{0} (Copy)": "{0} (kopēt)",
    "Are you sure you wish to delete this project?": "Vai tiešām vēlaties dzēst šo projektu?",
    "Are you sure to archive this event?": "Vai esat pārliecināts, ka vēlaties arhivēt šo notikumu?",
    "Are you sure to archive this project?": "Vai tiešām vēlaties arhivēt šo projektu?",
    "Are you sure to cancel this event?": "Vai jūs noteikti atceļat šo pasākumu?",
    "Are you sure to cancel this project?": "Vai tiešām vēlaties atcelt šo projektu?",
    "Communication": "Komunikācija",
    "Log": "Вход",
    "Create event workflow": "Izveidot notikumu darbplūsmu",
    "Create project workflow": "Izveidot projekta darbplūsmu",
    "Use workflow templates to set up tasks effectively or": "Izmantojiet darba plūsmas veidnes, lai efektīvi iestatītu uzdevumus vai",
    "Add tasks manually": "Pievienojiet uzdevumus manuāli",
    "Save bookmark": "Saglabāt grāmatzīmi",
    "Remove filters": "Noņemiet filtrus",
    "Filter": "Filtrs",
    "Show multiselect": "Rādīt vairāku atlasi",
    "To do today": "Izdarīt šodien",
    "This and next month": "Šajā un nākamajā mēnesī",
    "Last 3 months": "Pēdējie 3 mēneši",
    "Next 3 months": "Nākamie 3 mēneši",
    "Starts": "Sākas",
    "To do": "Darīt",
    "today": "šodien",
    "tomorrow": "rīt",
    "yesterday": "vakar",
    "Previous week": "Iepriekšējā nedēļa",
    "Group similar tasks": "Grupējiet līdzīgus uzdevumus",
    "Group by client": "Grupa pēc klienta",
    "Group by date": "Grupējiet pēc datuma",
    "Group by topic": "Grupējiet pēc tēmas",
    "Your details": "Jūsu dati",
    "City": "Pilsēta",
    "Regional format": "Reģionālais formāts",
    "Default company": "Noklusējuma uzņēmums",
    "Lock time entries notification": "Bloķēšanas laika ierakstu paziņojums",
    "Notify by": "Paziņot līdz",
    "Delete my account": "Dzēst manu kontu",
    "Attention": "Uzmanību",
    "Are you sure that you want to delete your account?": "Vai tiešām vēlaties dzēst savu kontu?",
    "Notification": "Paziņojums",
    "Notification & email": "Paziņojums un e-pasts",
    "Vacations / absence": "Atvaļinājumi / prombūtne",
    "Edit balance": "Rediģēt atlikumu",
    "View history": "Skatīt vēsturi",
    "Request": "Pieprasīt",
    "How long": "Cik ilgi",
    "Requested": "Pieprasīts",
    "Approved": "Apstiprināts",
    "Rejected": "Noraidīts",
    "In review": "Pārskatā",
    "Change": "Mainīt",
    "Agreements": "Līgumi",
    "New agreement": "Jauns līgums",
    "Change agreement": "Mainīt līgumu",
    "Stop demo": "Pārtraukt demonstrāciju",
    "Show": "Rādīt",
    "Don't show": "Nerādīt",
    "Don't send": "Nesūtiet",
    "Email workdays at 7 AM": "E-pasts darba dienās plkst. 7:00",
    "Email at 3 PM": "E-pasts pulksten 15:00",
    "Email at once": "E-pasts uzreiz",
    "Email Sundays at 11 PM": "E-pasts svētdienās plkst. 23:00",
    "First day of the month": "Mēneša pirmā diena",
    "to email": "uz e-pastu",
    "E-mail at once": "E-pasts uzreiz",
    "System": "Sistēma",
    "Person": "Persona",
    "Picture": "Bilde",
    "Time zone": "Laika zona",
    "Calendar settings": "Kalendāra iestatījumi",
    "Public holidays": "Publiskās brīvdienas",
    "Tax deadlines": "Nodokļu termiņi",
    "News": "Jaunumi",
    "External services": "Ārējie pakalpojumi",
    "Google log in": "Google piesakieties",
    "Microsoft log in": "Microsoft piesakieties",
    "Are you sure to remove microsoft?": "Vai tiešām noņemat Microsoft?",
    "Agreement": "Vienošanās",
    "Active agreement": "Aktīva vienošanās",
    "Weekly hours": "Iknedēļas stundas",
    "Are you sure to remove google?": "Vai tiešām noņemat Google?",
    "Edit supplier": "Rediģēt piegādātāju",
    "New supplier": "Jauns piegādātājs",
    "Are you sure you wish to delete this supplier?": "Vai tiešām vēlaties dzēst šo piegādātāju?",
    "Add supplier": "Pievienojiet piegādātāju",
    "Supplier types are not defined. Please go to the suppliers app settings to add.": "Piegādātāju veidi nav definēti. Lai pievienotu, lūdzu, atveriet piegādātāju lietotnes iestatījumus.",
    "No members yet": "Vēl nav neviena dalībnieka",
    "Edit group": "Rediģēt grupu",
    "Add group": "Pievienot grupu",
    "Are you sure to delete this user group?": "Vai tiešām dzēsīsiet šo lietotāju grupu?",
    "Get set up to work with team": "Sagatavojieties darbam ar komandu",
    "Company account allows you to use tools for teams, get deeper insights etc. Raise the quality of your team's workflow and lead a more profitable business.": "Uzņēmuma konts ļauj izmantot rīkus komandām, iegūt dziļāku ieskatu utt. Paaugstiniet savas komandas darbplūsmas kvalitāti un ienesīgāku uzņēmējdarbību.",
    "Create company account": "Izveidojiet uzņēmuma kontu",
    "By creating a company account you activate Uku free subscription for {0} days.": "Izveidojot uzņēmuma kontu, jūs aktivizējat Uku bezmaksas abonementu uz {0} dienām.",
    "You have invited {0}/{1} members": "Jūs esat uzaicinājis {0}/{1} dalībniekus",
    "Upgrade": "Jaunināt",
    "Resend invite": "Atkārtoti nosūtīt uzaicinājumu",
    "Send invite": "Nosūtīt ielūgumu",
    "View profile": "Skatīt profilu",
    "To add members to your team, you'll need to create a company account": "Lai savai komandai pievienotu dalībniekus, jums ir jāizveido uzņēmuma konts",
    "Export": "Eksportēt",
    "Re-invite sent": "Nosūtīts atkārtots ielūgums",
    "View report": "Skatīt pārskatu",
    "Member {0} will be deactivated.": "Dalībnieks {0} tiks deaktivizēts.",
    "Please select new member who will replace {0}.": "Lūdzu, atlasiet jaunu dalībnieku, kurš aizstās {0}.",
    "Select new member": "Izvēlieties jaunu dalībnieku",
    "NB! Deactivation process cannot be reversed": "NB! Deaktivizēšanas procesu nevar atsaukt",
    "Magic button settings": "Burvju pogas iestatījumi",
    "Create only one task per month": "Izveidojiet tikai vienu uzdevumu mēnesī",
    "Current month's tasks": "Pašreizējā mēneša uzdevumi",
    "extra work": "papildus darbs",
    "Without topic": "Bez tēmas",
    "Week": "Nedēļa",
    "Previous month": "Iepriekšējais mēnesis",
    "task | tasks": "uzdevums | uzdevumi",
    "Assign to": "Piešķirt",
    "Mark as done": "Atzīmēt kā pabeigtu",
    "Last": "Pēdējais",
    "Snooze": "Atlikt",
    "1 dependency": "1 atkarība",
    "{0} dependencies": "{0} atkarības",
    "Client request": "Klienta pieprasījums",
    "Unread notification emails": "Unread notification emails",
    "Unread internal comments": "Unread internal comments",
    "Add comment": "Pievienot komentāru",
    "Internal comment": "Iekšējais komentārs",
    "Portal message": "Portāla ziņojums",
    "Public message means that clients can read it and the client portal will notify them by email": "Publisks ziņojums nozīmē, ka klienti to var izlasīt un klientu portāls tos par to informēs pa e-pastu",
    "Type a comment": "Ierakstiet komentāru",
    "Send portal message": "Nosūtīt portāla ziņojumu",
    "Open timesheet": "Atvērt darba laika uzskaiti",
    "Pause timer": "Pārtraukuma stundas",
    "Mark undone": "Atzīmēt kā atsauktu",
    "Digitise": "Digitalizēt",
    "Documents sent to digitisation": "Dokumentu nosūtīšana digitalizācijai",
    "Followers": "Sekotāji",
    "Start / Due date": "Sākuma / izpildes datums",
    "Select topic": "Izvēlieties tēmu",
    "1 document": "1 dokuments",
    "{0} documents": "{0} dokumenti",
    "Download": "Lejupielādēt",
    "Download all": "Lejupielādēt visu",
    "Assign as task": "Piešķirt kā uzdevumu",
    "When selected, the task is sent as a task to the client": "Kad tas ir atlasīts, uzdevums tiek nosūtīts klientam kā uzdevums",
    "Auto finish": "Automātiskā apdare",
    "When selected, the task is marked done after client finishes it": "Kad tas ir atlasīts, uzdevums tiek atzīmēts kā pabeigts, kad klients to pabeidz",
    "Add comment / message": "Pievienot komentāru / ziņu",
    "Add email": "Pievienojiet e-pastu",
    "Add estimation": "Pievienojiet aprēķinu",
    "Add task field": "Pievienot uzdevumu lauku",
    "Add dependency": "Pievienojiet atkarību",
    "Drop files to upload": "Nometiet augšupielādējamos failus",
    "Task sent to client portal": "Uzdevums nosūtīts uz klienta portālu",
    "Task no longer assigned to client portal": "Uzdevums vairs nav piešķirts klienta portālam",
    "Save recurring task": "Saglabājiet periodisko uzdevumu",
    "Add to-do list": "Pievienojiet uzdevumu sarakstu",
    "Waiting for event status: {0}": "Gaidām notikuma statusu: {0}",
    "Waiting for project status: {0}": "Gaidām projekta statusu: {0}",
    "Edit template task": "Rediģēt veidnes uzdevumu",
    "Create recurring task": "Izveidojiet periodisku uzdevumu",
    "Make a copy": "Izveidojiet kopiju",
    "Add topic": "Pievienot tēmu",
    "Delete task": "Dzēst uzdevumu",
    "Delete task template": "Dzēst uzdevuma veidni",
    "Select task field": "Atlasiet uzdevuma lauku",
    "No custom fields available for this client": "Šim klientam nav pieejami pielāgoti lauki",
    "task": "uzdevums",
    "recurring task": "atkārtots uzdevums",
    "Do you intend to remove yourself from {0} or you want to delete it completely?": "Vai plānojat noņemt sevi no {0} vai vēlaties to dzēst pilnībā?",
    "This {1} is shared with {0}": "Šis {1} ir koplietots ar {0}",
    "Remove only me": "Noņemt tikai mani",
    "Time has been tracked to this task.": "Šim uzdevumam ir izsekots laiks.",
    "Are you sure to delete this task?": "Vai noteikti vēlaties dzēst šo uzdevumu?",
    "Undefined": "Nenoteikts",
    "COPY": "KOPĒT",
    "On task due date": "Uzdevuma izpildes datumā",
    "{0} day before": "{0} dienu iepriekš",
    "{0} days before": "{0} dienas iepriekš",
    "Edit workflow": "Rediģēt darbplūsmu",
    "Duplicate project": "Dublēt projektu",
    "Reset layout": "Atiestatīt izkārtojumu",
    "Any time": "Jebkurā laikā",
    "Assign user...": "Piešķirt lietotāju...",
    "1 min": "1 min",
    "5 min": "5 min",
    "10 min": "10 min",
    "30 min": "30 min",
    "1 h": "1 h",
    "Add notes": "Pievienojiet piezīmes",
    "Task start date": "Uzdevuma sākuma datums",
    "Task due date": "Uzdevuma izpildes termiņš",
    "Recurrence task": "Atkārtošanās uzdevums",
    "Search from one time templates": "Meklēšana pēc vienreizējām veidnēm",
    "Placeholders": "Vietturi",
    "New task": "Jauns uzdevums",
    "New recurring task": "Jauns atkārtots uzdevums",
    "+1 day": "+1 diena",
    "Edit comment": "Rediģēt komentāru",
    "Timer is running!": "Laika uzskaite darbojas!",
    "Continue time from {0}": "Turpināt laiku no {0}",
    "New time entry": "Jauns laika ieraksts",
    "Load more": "Ielādēt vairāk",
    "Are you sure to delete this time entry?": "Vai tiešām dzēsīsiet šo laika ierakstu?",
    "Save automated email": "Saglabājiet automātisko e-pastu",
    "Automation": "Automatizācija",
    "Are you sure to delete this email?": "Vai tiešām izdzēsīsiet šo e-pasta ziņojumu?",
    "Are you sure you wish to send this email immediately?": "Vai tiešām vēlaties nekavējoties nosūtīt šo e-pasta ziņojumu?",
    "replied to project email": "replied to project email",
    "replied to client email": "replied to client email",
    "commented": "komentēja",
    "Reply": "Atbildēt",
    "Are you sure to delete this comment?": "Vai tiešām dzēsīsit šo komentāru?",
    "replied to client portal email": "replied to client portal email",
    "sent a message": "nosūtīja ziņu",
    "replied to task email": "replied to task email",
    "failed to send": "neizdevās nosūtīt",
    "sent email": "nosūtīts e-pasts",
    "no one": "neviens",
    "created this task.": "izveidoja šo uzdevumu.",
    "Task was automatically created from forwarded e-mail": "Task was automatically created from forwarded e-mail",
    "Task was automatically created from client portal e-mail": "Task was automatically created from client portal e-mail",
    "Task was automatically created from client e-mail": "Task was automatically created from client e-mail",
    "Task was automatically created from project e-mail": "Task was automatically created from project e-mail",
    "requested assistance.": "pieprasīto palīdzību.",
    "updated this task.": "atjaunināja šo uzdevumu.",
    "tracked time to this task.": "uzskaitīja laiku līdz šim uzdevumam.",
    "finished this task.": "pabeidza šo uzdevumu.",
    "new comment.": "jauns komentārs.",
    "reassigned this task.": "šo uzdevumu pārdalīt.",
    "assigned the task to {0}.": "piešķirts uzdevums {0}.",
    "reminder.": "atgādinājums.",
    "deleted.": "dzēsts.",
    "completed the task, but Uku did not auto-finish this task because not all task requirements were met.": "pabeidza uzdevumu, bet Uku šo uzdevumu automātiski nepabeidza, jo nebija izpildītas visas uzdevuma prasības.",
    "sent task to client portal": "nosūtīts uzdevums uz klienta portālu",
    "assigned the task to client.": "piešķirts uzdevums klientam.",
    "assigned the task to company.": "uzdots uzdevums uzņēmumam.",
    "added attachment(s).": "pievienots(-i) pielikums(-i).",
    "added a comment.": "pievienots komentārs.",
    "added a message to {0}.": "pievienots ziņojums {0}.",
    "received a e-mail from {0}.": "received a e-mail from {0}.",
    "updated notes.": "atjauninātas piezīmes.",
    "made changes to checklist.": "veiktas izmaiņas kontrolsarakstā.",
    "created this task template.": "izveidoja šo uzdevuma veidni.",
    "updated this task template.": "atjaunināja šo uzdevuma veidni.",
    "recurring task assigned.": "uzdots atkārtots uzdevums.",
    "recurring task deleted.": "atkārtots uzdevums dzēsts.",
    "added email.": "pievienots e-pasts.",
    "changed email.": "mainīts e-pasts.",
    "deleted email.": "svītrots e-pasts.",
    "sent email.": "nosūtīts e-pasts.",
    "failed to send.": "neizdevās nosūtīt.",
    "added email": "pievienots e-pasts",
    "changed email": "mainīts e-pasts",
    "deleted email": "dzēsts e-pasts",
    "Member / Time": "Biedrs / laiks",
    "Client/topic": "Klients/tēma",
    "Client/task": "Klients/uzdevums",
    "Client/member": "Klients/biedrs",
    "Member/topic": "Dalībnieks/tēma",
    "Member/task": "Biedrs/uzdevums",
    "Member/client": "Biedrs/klients",
    "Member/date": "Dalībnieks/datums",
    "Date/member": "Datums/biedrs",
    "Grouped": "Sagrupēts",
    "Client/project": "Klients/projekts",
    "Project/member": "Projekts/dalībnieks",
    "Period balance": "Perioda bilance",
    "Reset balance": "Atiestatīt līdzsvaru",
    "Time entry has been confirmed or duration has been changed and duration will not dynamically update": "Laika ieraksts ir apstiprināts vai ilgums ir mainīts, un ilgums netiks dinamiski atjaunināts",
    "(Without project)": "(Bez projekta)",
    "Decline": "Noraidīt",
    "Accept": "Pieņemt",
    "Cancel decision": "Anulēt lēmumu",
    "Accepted": "Pieņemts",
    "Declined": "Noraidīts",
    "Report data has changed. Please update report.": "Pārskata dati ir mainīti. Lūdzu, atjauniniet ziņojumu.",
    "Agreed": "Piekritu",
    "Non billable": "Nav jāmaksā",
    "Export report to Excel": "Eksportēt atskaiti programmā Excel",
    "By default, we export the result of the selected filters with the columns of the configured table": "Pēc noklusējuma mēs eksportējam atlasīto filtru rezultātu ar konfigurētās tabulas kolonnām",
    "Add to export client custom fields": "Pievienojiet eksporta klienta pielāgotos laukus",
    "Save report": "Saglabāt atskaiti",
    "Export PDF": "Eksportēt PDF",
    "Export Excel": "Eksportēt Excel",
    "We have new version of": "Mums ir jauna versija",
    "Log out": "Iziet",
    "Previous day": "Iepriekšējā diena",
    "Next day": "Nākamā diena",
    "Mark all as read": "Atzīmēt visu kā izlasītu",
    "Search task/client": "Meklēt uzdevumu/klientu",
    "from client portal": "no klientu portāla",
    "Hide all": "Paslēpt visu",
    "Hide for 1 hour": "Slēpties 1 stundu",
    "Something went wrong": "Kaut kas nogāja greizi",
    "User authentication needed": "Nepieciešama lietotāja autentifikācija",
    "Invalid rights": "Nederīgas tiesības",
    "The object cannot be found": "Objektu nevar atrast",
    "Content too large": "Saturs ir pārāk liels",
    "An unknown error occurred": "Radās nezināma kļūda",
    "The action requested cannot be performed": "Pieprasīto darbību nevar veikt",
    "Go": "Aiziet",
    "Actual / monitoring (month)": "Faktiskais/uzraudzība (mēnesis)",
    "h": "h",
    "Actual": "Faktiskais",
    "Month": "Mēnesis",
    "I’m setting up your account": "Es izveidoju jūsu kontu",
    "Did you know that accounting firms that have started using Uku can serve 38% more clients in the same time.": "Vai zināji, ka grāmatvedības firmas, kas sākušas lietot Uku, var apkalpot par 38% vairāk klientu vienā un tajā pašā laikā.",
    "Let’s setup your company": "Izveidosim jūsu uzņēmumu",
    "Name of your company": "Jūsu uzņēmuma nosaukums",
    "Size of your team?": "Jūsu komandas lielums?",
    "Which software are you using?": "Kādu programmatūru jūs izmantojat?",
    "This knowledge will help us to improve Uku": "Šīs zināšanas palīdzēs mums uzlabot Uku",
    "What other software needs to be integrated?": "Kāda cita programmatūra ir jāintegrē?",
    "Book a demo": "Rezervējiet demonstrāciju",
    "Hi {0},": "Sveiki, {0},",
    "NO BOTS - ONLY HUMANS": "NAV ROBOTU - TIKAI CILVĒKI",
    "Start a 14 day free trial": "Sāciet 14 dienu bezmaksas izmēģinājumu",
    "“Uku is an incredibly functional software. Uku boosted our work management and helps us provide exceptional service.”": "“Uku ir neticami funkcionāla programmatūra. Uku uzlaboja mūsu darba vadību un palīdz mums nodrošināt izcilus pakalpojumus.",
    "The fastest way for you to decide if Uku can benefit {0} is a short {1} min call with our customer onboarding specialist.": "Ātrākais veids, kā jūs varat izlemt, vai Uku var sniegt labumu {0}, ir īss {1} minūšu zvans ar mūsu klientu uzņemšanas speciālistu.",
    "Hi, I'm Uku ": "Sveiki, es esmu Uku ",
    "I help to set up your account.": "Es palīdzu izveidot jūsu kontu.",
    "It only takes a minute.": "Tas aizņem tikai minūti.",
    "Choose": "Izvēlieties",
    "Your country": "Tava valsts",
    "Your language": "Tava valoda",
    "Begin": "Sāciet",
    "Let’s become friends": "Kļūsim par draugiem",
    "Your first name": "Jūsu vārds",
    "What is your field of work?": "Kāda ir jūsu darba joma?",
    "Your field of work": "Jūsu darba joma",
    "How will you use Uku?": "Kā tu izmantosi Uku?",
    "How did you hear about Uku?": "Kā tu uzzināji par Uku?",
    "Choose channel": "Izvēlieties kanālu",
    "Please specify how you heard about us": "Lūdzu, norādiet, kā jūs par mums dzirdējāt",
    "Let me know Uku's new features by email": "Paziņojiet man par Uku jaunajām funkcijām pa e-pastu",
    "Finish": "Pabeigt",
    "First name is required": "Jānorāda vārds",
    "Name is required": "Jānorāda vārds",
    "Team size is required": "Nepieciešams komandas lielums",
    "Surname is required": "Nepieciešams uzvārds",
    "Field is required": "Lauks ir jāaizpilda obligāti",
    "I will use Uku to work together with two or more teammates.": "Es izmantošu Uku, lai strādātu kopā ar diviem vai vairākiem komandas biedriem.",
    "I will use Uku by myself. This plan is free, but the features are limited.": "Es pats izmantošu Uku. Šis plāns ir bezmaksas, taču funkcijas ir ierobežotas.",
    "Media": "Plašsaziņas līdzekļi",
    "Through integration partner": "Ar integrācijas partnera starpniecību",
    "Referral by friend": "Drauga ieteikums",
    "Import speeds up your clients setup, smart choice!": "Importēšana paātrina jūsu klientu iestatīšanu, gudra izvēle!",
    "Last import: added {0}, updated {1}, skipped {2}, failed to import {3} client": "Pēdējā importēšana: pievienots {0}, atjaunināts {1}, izlaists {2}, neizdevās importēt {3} klientu",
    "Last import: added {0}, updated {1}, skipped {2}, failed to import {3} clients": "Pēdējā importēšana: pievienots {0}, atjaunināts {1}, izlaists {2}, neizdevās importēt {3} klientus",
    "Last import: added {0}, updated {1}, skipped {2}": "Pēdējā importēšana: pievienots {0}, atjaunināts {1}, izlaists {2}",
    "What's next? Correct the data of {0} clients and upload again.": "Ko tālāk? Labojiet {0} klientu datus un augšupielādējiet vēlreiz.",
    "failed_to_import.xlsx": "failed_to_import.xlsx",
    "Excel (XLS, XLSX) ": "Excel (XLS, XLSX) ",
    "Instead of entering clients one by one, you can use file import for a large customer base.": "Tā vietā, lai ievadītu klientus pa vienam, varat izmantot failu importēšanu lielai klientu bāzei.",
    "Import all Merit Aktiva clients and keep client data automatically updated": "Importējiet visus Merit Aktiva klientus un automātiski atjauniniet klientu datus",
    "Ignore": "Ignorēt",
    "NEW CLIENT": "JAUNS KLIENTS",
    "Preview": "Priekšskatījums",
    "Import started": "Sākta importēšana",
    "Only new clients": "Tikai jauni klienti",
    "Update data from company register": "Atjaunināt datus no uzņēmumu reģistra",
    "If switched on, the company data is updated using the local business register": "Ja tas ir ieslēgts, uzņēmuma dati tiek atjaunināti, izmantojot vietējo uzņēmumu reģistru",
    "We did not find a match in Äriregister": "Mēs neatradām atbilstību Äriregister",
    "We did not find a match in Companies House": "Uzņēmumu reģistrā (Companies House) neatradām atbilstību",
    "No integration yet": "Integrācijas vēl nav",
    "Uku match": "Uku atbilstība",
    "Business register nr.": "Uzņēmumu reģistra Nr.",
    "Company register": "Uzņēmumu reģistrs",
    "Upload file": "Augšupielādēt failu",
    "Before uploading your file": "Pirms faila augšupielādes",
    "Learn Uku’s data structure": "Uzziniet Uku datu struktūru",
    "Download and use our sample file to see exactly how we organize data in Uku": "Lejupielādējiet un izmantojiet mūsu parauga failu, lai precīzi redzētu, kā mēs organizējam datus Uku",
    "Download Client Import Example": "Lejupielādējiet klienta importēšanas piemēru",
    "Download Contact Import Example": "Lejupielādējiet kontaktpersonu importēšanas piemēru",
    "Fill in fields": "Aizpildiet laukus",
    "The only mandatory field is the company name. Make sure you've filled out all the necessary fields before uploading the file.": "Vienīgais obligātais lauks ir uzņēmuma nosaukums. Pirms faila augšupielādes pārliecinieties, vai esat aizpildījis visus nepieciešamos laukus.",
    "Learn more about mandatory fields": "Uzziniet vairāk par obligātajiem laukiem",
    "Create custom fields": "Izveidojiet pielāgotus laukus",
    "Some data fields may not be present by default. Make sure you create these custom fields before importing your data.": "Daži datu lauki pēc noklusējuma var nebūt pieejami. Pirms datu importēšanas noteikti izveidojiet šos pielāgotos laukus.",
    "Add new custom fields": "Pievienojiet jaunus pielāgotus laukus",
    "...or drag a file here": "...vai velciet failu šeit",
    "Only Excel (.xls, .xlsx) file types are supported": "Tiek atbalstīti tikai Excel (.xls, .xlsx) failu tipi",
    "Mapping": "Kartēšana",
    "First row is a header": "Pirmā rinda ir galvene",
    "Add field to all clients": "Pievienojiet lauku visiem klientiem",
    "Add client group": "Pievienojiet klientu grupu",
    "Fields for all clients": "Lauki visiem klientiem",
    "Import of {0} in progress": "Notiek {0} importēšana",
    "Import in progress": "Notiek importēšana",
    "It may take some time. You can do other activities in Uku at the same time, we will let you know when it is ready.": "Tas var aizņemt kādu laiku. Vienlaikus Uku var veikt citas aktivitātes, ziņosim, kad būs gatavs.",
    "Cancel import": "Atcelt importēšanu",
    "Are you sure you want to cancel import?": "Vai tiešām vēlaties atcelt importēšanu?",
    "Last updated": "Pēdējo reizi atjaunināts",
    "Contracts": "Līgumi",
    "Job name": "Darba nosaukums",
    "Workflow name": "Darbplūsmas nosaukums",
    "Details": "Sīkāka informācija",
    "Select jobs": "Izvēlieties darbus",
    "Select task plan": "Izvēlieties uzdevumu plānu",
    "of existing client": "esošā klienta",
    "You can also choose": "Varat arī izvēlēties",
    "existing client tasks plan": "esošais klienta uzdevumu plāns",
    "existing predefined jobs": "esošās iepriekš noteiktas darba vietas",
    "create a new plan": "izveidot jaunu plānu",
    "Select workflow": "Izvēlieties darbplūsmu",
    "existing project workflow": "esošā projekta darbplūsma",
    "existing workflow": "esošo darbplūsmu",
    "create a new workflow": "izveidot jaunu darbplūsmu",
    "New tasks template": "Jauna uzdevumu veidne",
    "to save template!": "lai saglabātu veidni!",
    "You can also add tasks from jobs": "Varat arī pievienot uzdevumus no darbiem",
    "or choose": "vai izvēlēties",
    "New workflow template": "Jauna darbplūsmas veidne",
    "You can also add tasks from existing workflow templates": "Varat arī pievienot uzdevumus no esošajām darbplūsmas veidnēm",
    "existing event workflow": "esošā notikumu darbplūsma",
    "Hide others": "Slēpt citus",
    "Update all events (New tasks)": "Visu notikumu atjaunināšana (Jauni uzdevumi)",
    "Update all projects (New tasks)": "Visu projektu atjaunināšana (jauni uzdevumi)",
    "Once": "Vienreiz",
    "Once a month": "Reizi mēnesī",
    "Once a quarter": "Reizi ceturksnī",
    "Once a year": "Vienreiz gadā",
    "Company workflow": "Uzņēmuma darba plūsma",
    "Company jobs": "Uzņēmuma darbavietas",
    "Default jobs": "Noklusējuma darbi",
    "ID": "ID",
    "Task title and labels": "Uzdevuma nosaukums un etiķetes",
    "Assigned and time": "Piešķirts un laiks",
    "Setup tasks for {0} event": "{0} notikuma iestatīšanas uzdevumi",
    "Setup tasks for {0} project": "{0} projekta iestatīšanas uzdevumi",
    "New job": "Jauns darbs",
    "Edit job": "Rediģēt darbu",
    "New workflow": "Jauna darbplūsma",
    "Save workflow": "Saglabājiet darbplūsmu",
    "Create task plan": "Izveidojiet uzdevumu plānu",
    "Confirm task plan": "Apstipriniet uzdevumu plānu",
    "Skip": "Izlaist",
    "Confirm workflow": "Apstipriniet darbplūsmu",
    "Client portal templates": "Klientu portāla veidnes",
    "Jobs": "Darbavietas",
    "Workflows": "Darbplūsmas",
    "Company workflows": "Uzņēmuma darba plūsmas",
    "Default workflows": "Noklusējuma darbplūsmas",
    "Company template saved": "Saglabāts uzņēmuma veidni",
    "Company template created": "Izveidota uzņēmuma veidne",
    "Format": "Formāts",
    "Currency": "Valūta",
    "Reference number": "Atsauces numurs",
    "Invoice description": "Rēķina apraksts",
    "Summarize invoice rows": "Apkopojiet rēķina rindas",
    "Summarized description": "Apkopots apraksts",
    "Reverse charge": "Apgrieztā iekasēšana",
    "Rounding": "Noapaļošana",
    "Time rounding will apply for each line": "Katrai rindai piemēro laika noapaļošanu",
    "Rounding increment (up)": "Noapaļošanas solis (uz augšu)",
    "Reply to": "Atbildēt uz",
    "Configuration": "Konfigurācija",
    "Invoice to parent company": "Rēķins mātesuzņēmumam",
    "Create all invoices under parent company.": "Izveidot visus rēķinus mātesuzņēmumā.",
    "User code": "Lietotāja kods",
    "Default": "Noklusējums",
    "Default value will apply for each line": "Noklusējuma vērtība tiks piemērota katrai rindai",
    "Number": "Numurs",
    "You can write any of the following in curly braces to invoice prefix field. When saving the contract the prefix is filled with the corresponding value.": "Rēķina prefiksa laukā varat ierakstīt jebkuru no tālāk norādītajām iekavās. Saglabājot līgumu, prefikss tiek aizpildīts ar atbilstošo vērtību.",
    "Copy to clipboard": "Kopēt starpliktuvē",
    "Invoice previous period": "Rēķins par iepriekšējo periodu",
    "Invoice period": "Rēķina periods",
    "Invoice next period": "Rēķins nākamajam periodam",
    "Client primary user": "Klienta primārais lietotājs",
    "Original client name": "Sākotnējais klienta nosaukums",
    "invoice date year": "rēķina datums gads",
    "last two digits of invoice date year": "rēķina datuma gada pēdējie divi cipari",
    "invoice date month": "rēķina datums mēnesis",
    "invoice date day": "rēķina datuma diena",
    "Copied to clipboard": "Kopēts starpliktuvē",
    "Contract": "Līgums",
    "Net total": "Net total",
    "Contract #": "Līgums #",
    "Invoice #": "Rēķins #",
    "Exported": "Eksportēts",
    "Sent": "Nosūtīts",
    "Net": "Tīkls",
    "Add invoice": "Pievienot rēķinu",
    "Change invoice number": "Mainīt rēķina numuru",
    "Review changes": "Pārskatiet izmaiņas",
    "Please review and approve changes to the related events": "Lūdzu, pārskatiet un apstipriniet izmaiņas saistītajos notikumos",
    "Please review and approve changes to the related projects": "Lūdzu, pārskatiet un apstipriniet izmaiņas saistītajos projektos",
    "Contains": "Satur",
    "contains": "satur",
    "Exactly": "Tieši tā",
    "is exactly": "ir tieši",
    "Greater than": "Lielāks nekā",
    "is greater than": "ir labāks par",
    "Less than": "Mazāk nekā",
    "is less than": "ir mazāks par",
    "Range": "Diapazons",
    "is in range of": "atrodas diapazonā",
    "is empty": "ir tukšs",
    "Task plan": "Uzdevuma plāns",
    "Edit plan": "Rediģēt plānu",
    "Use task plan templates to set up tasks effectively or add a task manually": "Izmantojiet uzdevumu plāna veidnes, lai efektīvi iestatītu uzdevumus vai pievienotu uzdevumu manuāli",
    "Add task manually": "Pievienojiet uzdevumu manuāli",
    "Quarterly": "Reizi ceturksnī",
    "Export excel": "Eksportēt Excel",
    "Print PDF": "Drukāt PDF",
    "Edit jobs": "Rediģēt darbus",
    "Replace plan tasks with job": "Aizstāt plāna uzdevumus ar darbu",
    "Select template": "Izvēlieties veidni",
    "member": "biedrs",
    "Tasks with user will be added to every selected client": "Uzdevumi ar lietotāju tiks pievienoti katram atlasītajam klientam",
    "Add even if job already applied": "Pievienot pat tad, ja darbs jau ir pieteikts",
    "Default user": "Noklusējuma lietotājs",
    "This will delete all tasks from client plan and put only selected template’s tasks in it": "Tas izdzēsīs visus uzdevumus no klienta plāna un ievietos tajā tikai izvēlētā veidnes uzdevumus",
    "Adding template will be ready in a minute. You can continue with work.": "Veidnes pievienošana būs gatava pēc minūtes. Jūs varat turpināt darbu.",
    "Add client": "Pievienot klientu",
    "Export clients": "Eksporta klienti",
    "Export client contacts": "Eksportēt klientu kontaktus",
    "client | clients": "klients | klientiem",
    "clients": "klientiem",
    "client(s) had errors": "klientam(-iem) bija kļūdas",
    "client(s) selected": "atlasītais(-i) klients(-i)",
    "Contract actions": "Līguma darbības",
    "Edit Members": "Rediģēt dalībniekus",
    "Edit monitoring": "Rediģēt uzraudzību",
    "Your company": "Tava kompānija",
    "Edit billing": "Rediģēt norēķinus",
    "Activate client portal": "Aktivizēt klientu portālu",
    "After activation, you can send tasks directly to all client's contacts who have an e-mail address.": "Pēc aktivizēšanas varat sūtīt uzdevumus tieši visiem klienta kontaktiem, kuriem ir e-pasta adrese.",
    "Send welcome invitation to client contacts": "Uzaicinājuma nosūtīšana klientu kontaktpersonām",
    "Who will receive an invitation?": "Kas saņems ielūgumu?",
    "Client contact who has one valid e-mail address": "Klienta kontakts, kuram ir viena derīga e-pasta adrese",
    "Client contact who has the client's portal open (default for all)": "Klienta kontakts, kuram ir atvērts klienta portāls (pēc noklusējuma visiem)",
    "How does the invitation work?": "Kā darbojas uzaicinājums?",
    "Uku creates and sends a 'Welcome task' to each client contact. It's created by the client primary user based on the 'Welcome to the Customer Portal' task template. Check it out under your company task templates. It will be translated according to the contact language.": "Uku izveido un nosūta \"Sagaidīšanas uzdevumu\" katram klienta kontaktam. To izveido klienta primārais lietotājs, pamatojoties uz uzdevuma \"Laipni lūgti klientu portālā\" veidni. Pārbaudiet to savā uzņēmuma uzdevumu veidņu sadaļā. Tas tiks tulkots atbilstoši kontaktpersonas valodai.",
    "Uku client portal always informs clients by email about new tasks.": "Uku klientu portāls vienmēr informē klientus pa e-pastu par jauniem uzdevumiem.",
    "View templates": "Skata veidnes",
    "Client portal activated": "Klientu portāls ir aktivizēts",
    "Company's name": "Uzņēmuma nosaukums",
    "Mark": "Atzīmēt",
    "Add members": "Pievienojiet dalībniekus",
    "Members and groups": "Dalībnieki un grupas",
    "Topic is required": "Tēma ir obligāta",
    "Entering time is required": "Nepieciešams ievadīšanas laiks",
    "Delete client": "Dzēst klientu",
    "Manage client fields": "Pārvaldiet klienta laukus",
    "Max 3 characters": "Maksimāli 3 rakstzīmes",
    "Are you sure you wish to delete this client?": "Vai tiešām vēlaties dzēst šo klientu?",
    "Deleting client data will also delete all client-related tasks.<br/><br/>NB! Client history will be deleted": "Dzēšot klienta datus, tiks dzēsti arī visi ar klientu saistītie uzdevumi.<br/><br/>NB! Klienta vēsture tiks dzēsta",
    "Owner": "Īpašnieks",
    "All clients that you add under {0} will be deleted later.</div>": "Visi klienti, kurus pievienojat sadaļā {0}, vēlāk tiks dzēsti.</div>",
    "Use this account for testing purposes only!": "Izmantojiet šo kontu tikai pārbaudes nolūkiem!",
    "Read more about the demo account": "Lasiet vairāk par demonstrācijas kontu",
    "Rights": "Tiesības",
    "Monitoring setup": "Uzraudzības iestatīšana",
    "Learn more about monitoring": "Uzziniet vairāk par uzraudzību",
    "selected": "atlasīts",
    "Invoicing": "Rēķinu izrakstīšana",
    "Billing template": "Rēķini veidne",
    "New": "Jauns",
    "Add row": "Pievienot rindu",
    "Delete contract": "Dzēst līgumu",
    "Product / description": "Produkta apraksts",
    "Qty": "Daudzums",
    "Product placeholders": "Produktu vietturi",
    "You can write any of the following lines in curly brackets to product description. When saving an invoice it will replace the text with the corresponding value.": "You can write any of the following lines in curly brackets to product description. When saving an invoice it will replace the text with the corresponding value.",
    "Template saved": "Veidne saglabāta",
    "Warning": "Brīdinājums",
    "Would you like to apply these changes to all clients using this contract template?": "Vai vēlaties piemērot šīs izmaiņas visiem klientiem, kuri izmanto šo līguma veidni?",
    "Yes, apply to all clients": "Jā, attiecas uz visiem klientiem",
    "You have made changes to time period that this billing contract applies to. This may change how affected unbilled services in the past and future will be invoiced. Please confirm that this change was intentional.": "Jūs esat veicis izmaiņas laika periodā, uz kuru attiecas šis rēķini līgums. Tas var mainīt veidu, kā tiks izrakstīti rēķini par ietekmētajiem neapmaksātajiem pakalpojumiem pagātnē un nākotnē. Lūdzu, apstipriniet, ka šīs izmaiņas bija tīšas.",
    "Are you sure to delete this template?": "Vai tiešām dzēsīsiet šo veidni?",
    "Save template": "Saglabāt veidni",
    "Save as template": "Saglabāt kā veidni",
    "Please note all changes made to contract will be lost": "Lūdzu, ņemiet vērā, ka visas līgumā veiktās izmaiņas tiks zaudētas",
    "Add contract": "Pievienojiet līgumu",
    "Manage contract templates": "Pārvaldiet līgumu veidnes",
    "Change account details": "Mainiet konta informāciju",
    "Country is required": "Valsts ir obligāta",
    "Address": "Adrese",
    "Postal code": "Pasta indekss",
    "State": "Valsts",
    "Uku is set up according to the field of work.": "Uku iekārto atbilstoši darba jomai.",
    "Size of the team": "Komandas lielums",
    "Website": "Website",
    "Delete account": "Dzēst kontu",
    "Deleting an account will also delete all clients associated with the account, their tasks, and their entire history. Are you sure that you want to delete your account?": "Dzēšot kontu, tiks dzēsti arī visi ar kontu saistītie klienti, viņu uzdevumi un visa vēsture. Vai tiešām vēlaties dzēst savu kontu?",
    "Yes, delete the account with all related data such as clients, tasks, and all history": "Jā, dzēsiet kontu ar visiem saistītajiem datiem, piemēram, klientiem, uzdevumiem un visu vēsturi",
    "These invoices cannot be sent. Check their status or error messages.": "Šos rēķinus nevar nosūtīt. Pārbaudiet to statusu vai kļūdas ziņojumus.",
    "Please confirm that you wish to proceed.": "Lūdzu, apstipriniet, ka vēlaties turpināt.",
    "Sending invoice | Sending invoices": "Rēķina sūtīšana | Rēķinu sūtīšana",
    "You are about to e-mail this invoice to customer. | You are about to e-mail these invoices to customers.": "Jūs gatavojaties nosūtīt šo rēķinu klientam pa e-pastu. | Jūs gatavojaties nosūtīt šos rēķinus klientiem pa e-pastu.",
    "Error in calculating invoice": "Kļūda rēķina aprēķināšanā",
    "Error in importing invoice": "Kļūda, importējot rēķinu",
    "Error in creating invoice": "Kļūda veidojot rēķinu",
    "Error in exporting invoice": "Eksportējot rēķinu, radās kļūda",
    "Error in sending invoice": "Kļūda, nosūtot rēķinu",
    "Calculating invoice": "Rēķina aprēķins",
    "Creating invoice": "Rēķina sastādīšana",
    "Exporting invoice": "Eksportē rēķinu",
    "Importing invoice": "Importē rēķinu",
    "Sending invoice": "Rēķina nosūtīšana",
    "Clear errors": "Notīrīt kļūdas",
    "Related work will be made billable again. The invoices will not be deleted from external systems, you will have to do that manually.": "Saistītie darbi atkal tiks apmaksāti. Rēķini no ārējām sistēmām netiks dzēsti, tas būs jādara manuāli.",
    "Delete invoice | Deleting invoices": "Dzēst rēķinu | Rēķinu dzēšana",
    "Selected net total": "Selected net total",
    "Nothing in invoices": "Rēķinos nekā nav",
    "Please make sure you have setup recurring billing for your clients": "Lūdzu, pārliecinieties, vai esat iestatījis saviem klientiem periodiskos norēķinus",
    "Draft": "Melnraksts",
    "Approval": "Apstiprinājums",
    "Created": "Izveidots",
    "Coming soon": "Drīzumā",
    "Selected invoices and related product info will be sent to accounting system.": "Atlasītie rēķini un ar tiem saistīto produktu informācija tiks nosūtīta uz grāmatvedības sistēmu.",
    "Piece": "Gabals",
    "Hour": "Stunda",
    "Delete row": "Dzēst rindu",
    "Out of ": "Beidzās ",
    " can be created": " var izveidot",
    "For ": "Priekš ",
    " invoicing period is still ongoing. Any work done in this period after creation of the invoice will not be invoiced.": " joprojām turpinās rēķinu izrakstīšanas periods. Par darbu, kas veikts šajā periodā pēc rēķina sastādīšanas, rēķins netiks izrakstīts.",
    "Invoice date will be set to today.": "Rēķina datums tiks iestatīts uz šodienu.",
    "Uku is about to create": "Uku gatavojas izveidot",
    " selected row, only | selected row, only ": " atlasītā rinda, tikai | tikai atlasītā rinda ",
    " invoice | invoices": " rēķins | rēķini",
    "These invoices cannot be exported. Check their status or error messages.": "Šos rēķinus nevar eksportēt. Pārbaudiet to statusu vai kļūdas ziņojumus.",
    "Exporting invoice | Exporting invoices": "Eksportē rēķinu | Eksportē rēķinus",
    "You are about to export this invoice to accounting. | You are about to export these invoices to accounting.": "Jūs gatavojaties eksportēt šo rēķinu uz grāmatvedību. | Jūs gatavojaties eksportēt šos rēķinus uz grāmatvedību.",
    "This invoice has already been exported. Are you sure you want to export it as a new invoice? | Some of these invoices have already been exported. Are you sure that you want to export them as new invoices?": "This invoice has already been exported. Are you sure you want to export it as a new invoice? | Some of these invoices have already been exported. Are you sure that you want to export them as new invoices?",
    "Download pdf": "Lejupielādēt pdf",
    "Create invoice": "Izveidot rēķinu",
    "Update status from {0}": "Atjaunināt statusu no {0}",
    "Show all lines": "Rādīt visas līnijas",
    "Calculate invoice": "Aprēķināt rēķinu",
    "Loading invoice...": "Notiek rēķina ielāde...",
    "Invalid Scoro credentials": "Nederīgi Scoro akreditācijas dati",
    "Please confirm the changes you have made to this invoice.": "Lūdzu, apstipriniet šajā rēķinā veiktās izmaiņas.",
    "NB! Note that changed invoice will not be automatically sent to customer or exported to external systems - you will have to do this manually.": "NB! Ņemiet vērā, ka mainītais rēķins netiks automātiski nosūtīts klientam vai eksportēts uz ārējām sistēmām – tas būs jādara manuāli.",
    "Invoice number already exists! Please confirm to save anyway.": "Rēķina numurs jau pastāv! Lūdzu, apstipriniet, lai jebkurā gadījumā saglabātu.",
    "Error in data": "Kļūda datos",
    "The invoicing period is still ongoing. Any work done in this period after creation of the invoice will not be invoiced.": "Joprojām turpinās rēķinu izrakstīšanas periods. Par darbu, kas veikts šajā periodā pēc rēķina sastādīšanas, rēķins netiks izrakstīts.",
    "Creation date": "Izveidošanas datums",
    "{0} days after": "{0} dienas pēc",
    "{0} day after": "{0} dienu pēc",
    "right away when": "uzreiz, kad",
    "start date": "sākuma datums",
    "due date": "gala termiņš",
    "finished": "pabeigts",
    "Entries count": "Ieraksti skaitās",
    "Entries excluding sales": "Ieraksti, izņemot pārdošanu",
    "Entries excluding bank": "Ieraksti, izņemot banku",
    "Entries excluding documents": "Ieraksti, izņemot dokumentus",
    "Documents (sales and purchases)": "Dokumenti (pārdošana un pirkšana)",
    "Cash entries": "Skaidras naudas ieraksti",
    "VAT entries": "PVN ieraksti",
    "Stock entries": "Akciju ieraksti",
    "Sale entries": "Pārdošanas ieraksti",
    "Purchase entries": "Pirkuma ieraksti",
    "Bank entries": "Bankas ieraksti",
    "Ledger entries": "Grāmatvedības ieraksti",
    "Depreciation entries": "Nolietojuma ieraksti",
    "Entry lines count": "Ievades rindas tiek skaitītas",
    "Company owner": "Uzņēmuma īpašnieks",
    "Activity": "Aktivitāte",
    "Oldest first": "Vecākais vispirms",
    "Newest first": "Jaunākais vispirms",
    "Quantity as time": "Daudzums kā laiks",
    "Quantity as number": "Daudzums kā skaitlis",
    "Quantity as time in number format": "Daudzums kā laiks skaitļu formātā",
    "No rounding": "Nav noapaļošanas",
    "min": "min",
    "hour": "stunda",
    "Last day of month": "Mēneša pēdējā diena",
    "Invoice line": "Rēķina rinda",
    "Task time total (per member)": "Uzdevuma kopējais laiks (vienam dalībniekam)",
    "Time entry": "Laika ieraksts",
    "Task finish date": "Uzdevuma izpildes termiņš",
    "Create separately": "Izveidot atsevišķi",
    "Merge into one": "Apvienot vienā",
    "No minimum": "Nav minimuma",
    "{0} minute": "{0} minūte",
    "{0} minutes": "{0} minūtes",
    "{0} hour": "{0} stunda",
    "{0} hours": "{0} stundas",
    "English": "Angļu",
    "Estonian": "Igauņu",
    "Danish": "Dāņu",
    "Lithuanian": "Lietuviešu",
    "Russian": "Krievu",
    "Finnish": "Somu",
    "Swedish": "Zviedru",
    "Norwegian": "Norvēģu",
    "Latvian": "Latviešu",
    "Bulgarian": "Bulgāru",
    "German": "Vācu",
    "Spanish": "Spāņu",
    "Polish": "Poļu",
    "Field: ": "Lauks: ",
    "Normal hours": "Normālas stundas",
    "Year": "Gads",
    "Estonia": "Igaunija",
    "Finland": "Somija",
    "Poland": "Polija",
    "Connection successful!": "Savienojums veiksmīgs!",
    "User": "Lietotājs",
    "None": "Nav",
    "Error!": "Kļūda!",
    "Pending": "Gaida",
    "Finished": "Pabeigts",
    "Text": "Teksts",
    "Choice": "Izvēle",
    "Yes/No": "Jā / nē",
    "Integer": "Vesels skaitlis",
    "Multiple choice": "Vairākas izvēles iespējas",
    "URL": "URL",
    "Multiple users": "Vairāki lietotāji",
    "Multiline text": "Daudzrindu teksts",
    "Must be a integer": "Jābūt veselam skaitlim",
    "Must be a date": "Jābūt datumam",
    "Must be a valid e-mail address": "Jābūt derīgai e-pasta adresei",
    "Unknown choice": "Nezināma izvēle",
    "Some errors occurred:": "Radās dažas kļūdas:",
    "Unknown network error": "Nezināma tīkla kļūda",
    "Could not connect to the service": "Nevarēja izveidot savienojumu ar pakalpojumu",
    "Reload this page": "Pārlādēt šo lapu",
    "Invoice paid": "Rēķins apmaksāts",
    "Annulled": "Anulēts",
    "Processing": "Apstrāde",
    "You are about to deactivate this app.": "Jūs gatavojaties deaktivēt šo lietotni.",
    "You are about to disconnect this app.": "Jūs gatavojaties atvienot šo lietotni.",
    "Do you also want to activate billing to get the most out of Uku?": "Vai vēlaties arī aktivizēt norēķinus, lai maksimāli izmantotu Uku?",
    "Invoice": "Rēķins",
    "Clients - Monitoring": "Klienti - Uzraudzība",
    "Links": "Saites",
    "New template": "Jauna veidne",
    "Import Clients from Excel": "Importēt klientus no Excel",
    "Importer": "Importētājs",
    "Import clients from Excel": "Importēt klientus no Excel",
    "Account settings": "Konta iestatījumi",
    "Empty": "Tukšs",
};
export default translations